import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import DataTable from "react-data-table-component";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import {
  GetAllUserWithSystemPackageDetail,
  GetUserWithSystemPackageDetail,
  UserPackageCreate,
  GetAllSystemPackage,
  CreateSystempackage,
  GetAllGenericListing,
  CreateUserCustomPackage,
  UserPackagecancelbysupperadmin,
  Deleteuserpendingpackagebysupperadmin,
  CashUserPendingPackageCreate,
  UserPendingPackageCreate,
  CashUserPackageCreate,
  GetPreDefinedPackageListByIsWebBySuperadmin,
  GetAllUserWithSystemPackageDetailWithSearching,
  GetFixedCurrencyListSuperadmin,
  GetAllCurrencyListSuperadmin,
  GetPackageDetailWithCurrencyListBySuperadmin,
  IsCheckUserPackageUpgradeOrNot,
  getUsrActivePackageDetailByuserid,
  sendPaymentlink
} from "../../api/packageApi";
import {
  CheckUserIslock
} from "../../api/apiuser.js";
import Config from "../../Config.js";
import swal from "sweetalert";
import moment from "moment";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import { usePaymentInputs, PaymentInputsWrapper } from "react-payment-inputs";
import images from "react-payment-inputs/images";
import Select from "react-select";
import { NumericFormat } from "react-number-format";
import classnames from "classnames";


function User() {
  const [userdetailmadalOpen, setuserdetailmadalOpen] = useState(false);
  const [userinfo, setuserinfo] = useState(null);
  const [userpackagelist, setuserpackagelist] = useState([]);
  const [activeplan, setactiveplan] = useState("");
  const [selectuserID, setselectuserID] = useState("");
  let history = useHistory();
  let [userDetail, setUserDetail] = useState([]);
  const [SystemPackagemonthlyList, setSystemPackageMonthlyList] = useState([]);
  const [SystemPackageList, setSystemPackageList] = useState([]);
  const [SystemPackageannuallyList, setSystemPackageAnnuallyList] = useState(
    []
  );
  
  const [monthlyselectsubscribedpackage, setMonthlyselectsubscribedpackage] =
    useState("");
  const [Yearlyselectsubscribedpackage, setYearlyselectsubscribedpackage] =
    useState("");
  const [showpaymentmethod, setshowpaymentmethod] = useState();

  const [PackageModalisOpen, setPackageModalisOpen] = useState(false);
  const [PendingPackageModalisOpen, setPendingPackageModalisOpen] =
    useState(false);

  const [token, setToken] = useState("");
  const [number, setNumber] = React.useState("");
  const [holder, setHolder] = React.useState("");
  const [expiry, setExpiry] = React.useState("");
  const [cvv, setCvv] = React.useState("");
  const [focus, setfocus] = React.useState("");
  const [loading, setisLoading] = React.useState(false);
  const [Allloading, setAllisLoading] = React.useState(false);
  const [userloading, setuserisLoading] = React.useState(false);
  const [Detailisloading, setDetailisloading] = React.useState(false);
  const [loadingsendPayment, setloadingsendPayment] = React.useState(false);
  const [totalPrice, settotalPrice] = React.useState("");
  const [loadingCreateCustomisedPackage, setloadingCreateCustomisedPackage] = React.useState(false);

  const [isPaymentshow, setisPaymentshow] = useState(false);

  const [isMonthly, setisMonthly] = useState(true);
  const [isYearly, setisYearly] = useState(false);
  const [autorenewal, setautorenewal] = useState(false);

  const [packageaddeditmodalopen, setpackageaddeditmodalopen] = useState(false);
  const [IsWeb, setIsWeb] = useState(true);
  const [IsCustom, setIsCustom] = useState(true);
  const [ChatEnabled, setChatEnabled] = useState(true);
  const [AutoRenewal, setAutoRenewal] = useState(true);
  const [SSLCertificate, setSSLCertificate] = useState(true);
  const [AdvanceQrCodeSearch, setAdvanceQrCodeSearch] = useState(true);
  const [QrCodeSaveInWallet, setQrCodeSaveInWallet] = useState(true);
  const [QrCodeCategoryManaged, setQrCodeCategoryManaged] = useState(true);
  const [ExportQrCode, setExportQrCode] = useState(true);
  const [EmailSupport, setEmailSupport] = useState(true);
  const [IndividualSupport, setIndividualSupport] = useState(true);
  const [IndividualPhoneSupport, setIndividualPhoneSupport] = useState(true);
  const [WhiteLabelling, setWhiteLabelling] = useState(true);
  const [YourBranding, setYourBranding] = useState(true);
  const [packagename, setpackagename] = useState("");
  const [packagenameError, setpackagenameError] = useState("");
  const [systempackage, setSystempackage] = useState([]);
  const [packagecategory, setPackagecategory] = useState([]);
  const [dynamicQrCodeCount, setDynamicQrCodeCount] = useState("");
  const [dynamicQrCodeCountError, setDynamicQrCodeCountError] = useState("");
  const [bulkQrCodeCount, setbulkQrCodeCount] = useState("");
  const [bulkQrCodeCountError, setBulkQrCodeCountError] = useState("");
  const [monthlyCodeCount, setMonthlyCodeCount] = useState("");
  const [monthlyCodeCountError, setmonthlyCodeCountError] = useState("");
  const [subaccountCount, setSubaccountCount] = useState("");
  const [subaccountCountError, setSubaccountCountError] = useState("");
  const [dataStorageCount, setDataStorageCount] = useState("");
  const [dataStorageCountError, setDataStorageCountError] = useState("");
  const [noofchatuserCount, setNoofchatuserCount] = useState("");
  const [noofchatuserCountError, setNoofchatuserCountError] = useState("");
  const [staticCodeCount, setStaticCodeCount] = useState("");
  const [staticCodeCountError, setStaticCodeCountError] = useState("");
  const [selectpackageCategory, setselectpackageCategory] = useState("");
  const [selectpackageCategoryError, setselectpackageCategoryError] =
    useState("");
  const [SystempackageID, setSystempackageID] = useState("");
  const [personaldynamicQrCodeCount, setPersonaldynamicQrCodeCount] =
    useState("");
  const [personaldynamicQrCodeCountError, setPersonaldynamicQrCodeCountError] =
    useState("");

  const [userActivePackageList, setuserActivePackageList] = useState([]);
  const [userPreviousPackageList, setuserPreviousPackageList] = useState([]);

  const [userPendingPackageList, setuserPendingPackageList] = useState([]);
  const [ActiveselectedRows, setActiveSelectedRows] = useState([]);
  const [PreviousselectedRows, setPreviousSelectedRows] = useState([]);
  const [PendingselectedRows, setPendingSelectedRows] = useState([]);
  const [UserselectedRows, setUserSelectedRows] = useState([]);
  const [iscash, setiscash] = useState(true);
  const [isusercase, setUserCase] = useState(false);
  const userRef = useRef(null);
  const [selectpendingPackage, setselectpendingPackage] = useState(null);

  const Packageinforef = useRef(null);
  const [UsersassignedpackageinfoIsshow, setUsersassignedpackageinfoIsshow] =
    useState(false);

  const [activePill, setactivePill] = useState("1");

  const [searchEmail, setsearchEmail] = useState("");
  const [searchName, setsearchName] = useState("");
  const [searchOS, setsearchOS] = useState("");
  const [searchPackageID, setsearchPackageID] = useState("");
  const [searchSystemPackageList, setsearchSystemPackageList] = useState([]);

  const [CurrencyList, setCurrencyList] = useState([]);
  const [FixCurrencyList, setFixCurrencyList] = useState([]);

  const [IsMonthly, setIsMonthly] = useState(true);
  const [IsYearly, setIsYearly] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionIscash, setSelectedOptionCash] = useState(null);
  const [selectedOptionError, setSelectedOptionError] = useState("");
  const [selectedcurrency, setSelectedcurrency] = useState([]);
  const [selectedcurrencyCash, setSelectedcurrencyCash] = useState([]);
  const [isdisabled, setisdisabled] = useState(false);
  const [CurrencyPricelist, setCurrencyPricelist] = useState([]);
  const [CurrencyPriceID, setCurrencyPriceID] = useState("");
  const [CurrencyPriceError, setCurrencyPriceError] = useState("");
  const [SelectedPackageError, setSelectedPackageError] = useState("");

  const [AssignCurrencyPricelist, setAssignCurrencyPricelist] = useState([]);
  const [AssignCurrencyPriceID, setAssignCurrencyPriceID] = useState("");

  const [isPackageDetailShow, setisPackageDetailShow] = React.useState(false);
  const [PackageDetailitem, setPackageDetailitem] = React.useState(null);

  const [UserPackageInfo, setUserPackageInfo] = useState(null);
  const [isstripePay, setisstripePay] = useState('Stripepay');
  const togglePill = (pill) => {
    if (activePill !== pill) {
      setactivePill(pill);
    }
  };

  const {
    meta,
    wrapperProps,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
    getCardImageProps,
  } = usePaymentInputs();

  const toggleQrCodeModal = async (item_id, item_packagename, iswebuser) => {
    if (item_id?.type === "click") {
      setuserdetailmadalOpen(false);
      userRef.current = null;
      setuserinfo(null);
      setselectuserID("");
      setactiveplan("");
      setuserActivePackageList([]);
      setuserPendingPackageList([]);
      setuserPreviousPackageList([]);
      setactivePill("1");
      return;
    }
    if (item_id !== null && item_id !== undefined && item_id !== "") {
      setIsWeb(iswebuser);
      await getUserWithSystemPackageDetail(item_id);
      //await getAllSystemPackageUser(iswebuser);
      // await getfixePackage(iswebuser, true);

      setselectuserID(item_id);
      setactiveplan(item_packagename);
      setuserdetailmadalOpen(true);
    } else {
      setselectuserID("");
      setuserdetailmadalOpen(false);
      setuserinfo(null);
      setuserActivePackageList([]);
      setuserPendingPackageList([]);
      setuserPreviousPackageList([]);
      setactivePill("1");
    }
  };

  useEffect(() => {
    console.log("ActiveselectedRows", ActiveselectedRows);
    console.log("PreviousselectedRows", PreviousselectedRows);
    console.log("PendingselectedRows", PendingselectedRows);
  }, [ActiveselectedRows, PreviousselectedRows, PendingselectedRows]);

  const handleChangeActive = useCallback((state) => {
    setActiveSelectedRows(state.selectedRows);
  }, []);
  const handleChangePending = useCallback((state) => {
    setPendingSelectedRows(state.selectedRows);
  }, []);
  const handleChangePrev = useCallback((state) => {
    setPreviousSelectedRows(state.selectedRows);
  }, []);
  const handleChangeUser = useCallback((state) => {
    setUserSelectedRows(state.selectedRows);
  }, []);

  useEffect(() => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === "" ||
      checkLogin === undefined ||
      checkLogin === null
    ) {
      history.push("/Login");
    } else {
      getFixedCurrencyListSuperadmin();
      getAllCurrencyListSuperadmin();
      //getAllUserWithSystemPackageDetail();
      getAllUserWithSystemPackageDetailWithSearching("", "", "", "", "");
      getAllSystemPackage();
      getAllGenericListing();
    }
  }, []);

  const getFixedCurrencyListSuperadmin = async () => {
    try {
      let response = await GetFixedCurrencyListSuperadmin();
      if (response) {
        setFixCurrencyList(response);
      } else {
        setFixCurrencyList([]);
      }
    } catch (error) {
      setFixCurrencyList([]);
    }
  };
  const getAllCurrencyListSuperadmin = async () => {
    try {
      let response = await GetAllCurrencyListSuperadmin();
      if (response) {
        setCurrencyList(response);
      } else {
        setCurrencyList([]);
      }
    } catch (error) {
      setCurrencyList([]);
    }
  };

  const getAllSystemPackage = async () => {
    setAllisLoading(true);
    let response = await GetAllSystemPackage();
    if (response !== null && response !== "" && response !== undefined) {
      setsearchSystemPackageList(response);
      setAllisLoading(false);
    } else {
      setsearchSystemPackageList([]);
      setAllisLoading(false);
    }
  };
  const getAllGenericListing = async () => {
    let response = await GetAllGenericListing("packagecategory");
    setPackagecategory(response);
  };
  const getAllUserWithSystemPackageDetail = async () => {
    setuserisLoading(true);
    console.log("StartDate =", new Date());
    let response = await GetAllUserWithSystemPackageDetail();
    if (response) {
      console.log("StartDate159 =", new Date());
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setuserisLoading(false);
      setUserDetail(response);
    } else {
      setuserisLoading(false);
      setUserDetail([]);
    }
    console.log("StartDate169 =", new Date());
    // setUserDetail(response);
  };

  const getAllUserWithSystemPackageDetailWithSearching = async (
    UserEmail,
    UserName,
    OS,
    UserPackageID
  ) => {
    setuserisLoading(true);
    console.log("StartDate =", new Date());
    let response = await GetAllUserWithSystemPackageDetailWithSearching(
      UserEmail,
      UserName,
      OS,
      UserPackageID
    );
    if (response) {
      console.log("StartDate159 =", new Date());
      response?.forEach((item, index) => {
        item.sr = index + 1;
      });
      setuserisLoading(false);
      setUserDetail(response);
    } else {
      setuserisLoading(false);
      setUserDetail([]);
    }
    console.log("StartDate169 =", new Date());
    // setUserDetail(response);
  };

  const getfixePackage = async (isweb, isMonthly) => {
    // setAllisLoading(true);
    let response = await GetPreDefinedPackageListByIsWebBySuperadmin(
      isweb,
      isMonthly
    );
    if (response !== null && response !== undefined && response !== "") {
      if (isMonthly === true) {
        setSystemPackageMonthlyList(response);
        setSystemPackageAnnuallyList([]);
      } else {
        setSystemPackageMonthlyList([]);
        setSystemPackageAnnuallyList(response);
      }
      // setAllisLoading(false);
    } else {
      setSystemPackageMonthlyList([]);
      setSystemPackageAnnuallyList([]);
      // setAllisLoading(false);
    }
  };

  const getAllSystemPackageUser = async (isweb) => {
    setAllisLoading(true);
    //setIsWeb(isweb);
    setisdisabled(true);
    let response = await GetPreDefinedPackageListByIsWebBySuperadmin(isweb);
    if (response !== null && response !== "" && response !== undefined) {
      setSystemPackageList(response);
      let Monthlylist = response
        .filter((x) => x.packageName?.toLowerCase() !== "free")
        .map((item) => {
          return {
            _id: item._id,
            text: item?.packageName + " £ " + item?.monthlyPrice + " /Monthly",
          };
        });

      let Annuallylist = response
        .filter((x) => x.packageName?.toLowerCase() !== "free")
        .map((item) => {
          return {
            _id: item._id,
            text: item?.packageName + " £  " + item?.annuallyPrice + " /Yearly",
          };
        });

      setSystemPackageMonthlyList(Monthlylist);
      setSystemPackageAnnuallyList(Annuallylist);
      setAllisLoading(false);
    } else {
      setSystemPackageMonthlyList([]);
      setSystemPackageAnnuallyList([]);
      setAllisLoading(false);
    }
  };

  const GetUsrActivePackageDetail = async (userid) => {
    try {
      let data = await getUsrActivePackageDetailByuserid(userid);
      if (data != null && data?._id !== null && data?._id !== "" && data?._id !== undefined) {
        console.log("GetUserPackage===>", data)
        setUserPackageInfo(data)
      }
    } catch (error) {
      console.log("getPackageCurrencyListE5rror==>", error)
    }


  };
  const getUserWithSystemPackageDetail = async (userid) => {
    setDetailisloading(true);
    if (userid) {
      GetUsrActivePackageDetail(userid)
    }
    let response = await GetUserWithSystemPackageDetail(userid);
    if (response !== null) {
      let userActivePackageListTemp = response?.userActivePackageList;
      if (
        userActivePackageListTemp !== null &&
        userActivePackageListTemp !== "" &&
        userActivePackageListTemp !== undefined &&
        userActivePackageListTemp?.length > 0
      ) {
        userActivePackageListTemp?.forEach((item, index) => {
          item.sr = index + 1;
        });
        setactiveplan(userActivePackageListTemp[0].packageName);
        setuserActivePackageList(userActivePackageListTemp);
      } else {
        setactiveplan("");
        setuserActivePackageList([]);
      }
      let userPreviousPackageListTemp = response?.userPreviousPackageList;
      if (
        userPreviousPackageListTemp !== null &&
        userPreviousPackageListTemp !== "" &&
        userPreviousPackageListTemp !== undefined &&
        userPreviousPackageListTemp?.length > 0
      ) {
        userPreviousPackageListTemp?.forEach((item, index) => {
          item.sr = index + 1;
        });
        setuserPreviousPackageList(userPreviousPackageListTemp);
      } else {
        setuserPreviousPackageList([]);
      }
      let userPendingPackageListTemp = response?.userPendingPackageList;
      if (
        userPendingPackageListTemp !== null &&
        userPendingPackageListTemp !== "" &&
        userPendingPackageListTemp !== undefined &&
        userPendingPackageListTemp?.length > 0
      ) {
        userPendingPackageListTemp?.forEach((item, index) => {
          item.sr = index + 1;
        });
        setuserPendingPackageList(userPendingPackageListTemp);
      } else {
        setuserPendingPackageList([]);
      }
      setuserinfo(response);
      userRef.current = response;

      setDetailisloading(false);
    } else {
      setuserinfo(null);
      userRef.current = null;
      setuserPendingPackageList([]);
      setuserPreviousPackageList([]);
      setactiveplan("");
      setuserActivePackageList([]);
      setDetailisloading(false);
    }
  };

  const OnselectPackageinfo = (item) => {
    Packageinforef.current = item;
    setUsersassignedpackageinfoIsshow(true);
  };

  const usercolumns = useMemo(
    () => [
      {
        name: "Sr.no",
        // selector: (row, index) => index + 1,
        selector: (row, index) => row?.sr,
        sortable: true,
        width: "5rem",
        // grow: 1,
      },
      {
        name: "Email",
        selector: (row) => row.email,
        sortable: true,
      },
      {
        name: "Image",
        sortable: false,
        width: "6rem",
        cell: (row) => {
          return row?.image !== null ? (
            <img
              src={Config.contentUrl + row?.image}
              style={{ height: "50px", width: "50px " }}
            ></img>
          ) : (
            <img
              src="../assets/img/new-images/images.png"
              style={{ height: "50px", width: "50px " }}
            ></img>
          );
        },
      },
      {
        name: "Name",
        selector: (row) => row.name,
        sortable: true,
      },
      {
        name: "Phone no.",
        selector: (row) => row.phoneNumber,
        sortable: true,
        width: "9rem",
      },
      {
        name: "Web / Mobile ",
        width: "9rem",
        selector: (row) => row.isWeb,
        // selector: (row) => ,
        cell: (row) => {
          return row.isWeb === false ? <h5>Mobile</h5> : <h5>Web</h5>;
        },
        sortable: true,
      },

      {
        name: "Active Package",
        selector: (row) => (row.packageName ? row.packageName : "N/A"),
        sortable: true,
        width: "9rem",
      },
      {
        name: "Action",
        cell: (row) => {
          return (
            <div>
              <button
                onClick={() => {
                  toggleQrCodeModal(row?._id, row?.packageName, row?.isWeb);
                }}
                type="button"
                className="btn btn-primary btn-sm mr-2"
              >
                <i className="ion ion-md-create "></i>
              </button>
            </div>
          );
        },
      },
    ],
    []
  );
  const Activepackagecolumns = useMemo(
    () => [
      {
        name: "Sr.no",
        selector: (row, index) => row?.sr,
        sortable: true,
      },
      {
        name: "Package name",
        selector: (row) => row.packageName,
        sortable: true,
        width: "10rem",
      },
      {
        name: "Currency",
        selector: "currencyName",
        sortable: true,
        cell: (row) => {
          return (
            <div>
              <span>{row?.currencyName ? row?.currencyName : "N/A"}</span>
            </div>
          );
        },
      },
      {
        name: "Price",
        selector: (row) => row.price,
        sortable: true,
        cell: (row) => {
          return (
            <div>
              <span>
                {row?.currencyOtherName ? row?.currencyOtherName : "N/A"}
                {row?.price ? row?.price : "0"}
              </span>
            </div>
          );
        },
      },
      {
        name: "Payment Type",
        selector: (row) => row.isCash,
        width: "9rem",
        sortable: true,
        cell: (row) => {
          return (
            <div>
              <span>{row?.isCash === true ? "Cash" : "Card"}</span>
            </div>
          );
        },
      },
      {
        name: "Status",
        selector: (row) => (row?.isActive === true ? "Active" : "Deactive"),
        sortable: true,
      },
      {
        name: "Yearly/Monthly",
        selector: (row) => (row?.isMonthly === true ? "Monthly" : "Yearly"),
        sortable: true,
        width: "9rem",
      },
      {
        name: "Start date ",
        selector: "startDate",
        sortable: true,
        width: "9rem",
        cell: (row) => {
          let date = new Date(row?.startDate);
          let dateMDY = `${date.getDate()}-${date.getMonth() + 1
            }-${date.getFullYear()}`;
          return (
            <div>
              <span>{dateMDY}</span>
            </div>
          );
        },
      },
      {
        name: "End date ",
        selector: "endDate",
        width: "9rem",
        sortable: true,
        cell: (row) => {
          let date = new Date(row?.endDate);
          let dateMDY = `${date.getDate()}-${date.getMonth() + 1
            }-${date.getFullYear()}`;
          return (
            <div>
              <span>{dateMDY}</span>
            </div>
          );
        },
      },
      {
        name: "Duration ",
        selector: "Duration ",
        sortable: true,
        cell: (row) => {
          return (
            <div>
              <span>{row?.durationDays ? row?.durationDays : "N/A"}</span>
            </div>
          );
        },
      },
      // {
      //   name: "Dynamic QrCode Count",
      //   selector: (row) =>
      //     row?.apDynamicQrCodeCount === -1
      //       ? "Unlimited"
      //       : row?.apDynamicQrCodeCount,
      //   sortable: true,
      // },
      // {
      //   name: "Dynamic QrCode Count Used",
      //   selector: (row) => row?.apDynamicQrCodeCountUsed,
      //   sortable: true,
      // },
      // {
      //   name: "Bulk QrCode Count",
      //   selector: (row) =>
      //     row?.bulkQrCodeCount === -1 ? "Unlimited" : row?.bulkQrCodeCount,
      //   sortable: true,
      // },
      // {
      //   name: "Bulk QrCode Count Used",
      //   selector: (row) => row?.bulkQrCodeCountUsed,
      //   sortable: true,
      // },
      // {
      //   name: "Personal Dynamic QrCode Count",
      //   selector: (row) =>
      //     row?.dynamicQrCodeCount === -1
      //       ? "Unlimited"
      //       : row?.dynamicQrCodeCount,
      //   sortable: true,
      // },
      // {
      //   name: "Personal Dynamic QrCode Count Used",
      //   selector: (row) => row?.dynamicQrCodeCountUsed,
      //   sortable: true,
      // },

      {
        name: "Action",
        cell: (row) => {
          return (
            <div>
              <button
                onClick={() => {
                  OnselectPackageinfo(row);
                }}
                type="button"
                className="btn me-1 bg-info btn-sm mr-2 ml-2 mb-2 mt-2"
              >
                <i className="fa fa-info-circle "></i>
                {/* Info */}
              </button>
              <button
                onClick={() => {
                  Cancelyoursubscription();
                }}
                type="button"
                className="btn btn-danger btn-sm mr-2 ml-2 "
              >
                <i className="fa fa-times  "></i>
                {/* Cancel Plan */}
              </button>
            </div>
          );
        },
      },
    ],
    []
  );
  const Prevpackagecolumns = useMemo(
    () => [
      {
        name: "Sr.no",
        selector: (row, index) => row?.sr,
        sortable: true,
      },
      {
        name: "Package name",
        selector: (row) => row.packageName,
        sortable: true,
      },
      // {
      //   name: "Price",
      //   selector: (row) => row.price,
      //   sortable: true,
      // },
      {
        name: "Price",
        selector: (row) => row.price,
        sortable: true,
        cell: (row) => {
          return (
            <div>
              <span>
                {row?.currencyOtherName ? row?.currencyOtherName : "N/A"}
                {row?.price ? row?.price : "0"}
              </span>
            </div>
          );
        },
      },
      {
        name: "Payment Type",
        selector: (row) => row.isCash,
        width: "9rem",
        sortable: true,
        cell: (row) => {
          return (
            <div>
              <span>{row?.isCash === true ? "Cash" : "Card"}</span>
            </div>
          );
        },
      },
      // {
      //   name: "Previous plan",
      //   selector: (row) => (row?.isActive === true ? "Active" : "Deactive"),
      //   sortable: true,
      // },
      // {
      //   name: "Yearly/Monthly",
      //   selector: (row) => (row?.isMonthly === true ? "Monthly" : "Yearly"),
      //   sortable: true,
      // },
      {
        name: "Dynamic QrCode Count",
        selector: (row) => row?.apDynamicQrCodeCount === -1 ? "Unlimited" : row?.apDynamicQrCodeCount,
        sortable: true,
      },
      {
        name: "Dynamic QrCode Count Used",
        selector: (row) => row?.apDynamicQrCodeCountUsed,
        sortable: true,
      },
      {
        name: "Bulk QrCode Count",
        selector: (row) =>
          row?.bulkQrCodeCount === -1 ? "Unlimited" : row?.bulkQrCodeCount,
        sortable: true,
      },
      {
        name: "Bulk QrCode Count Used",
        selector: (row) => row?.bulkQrCodeCountUsed,
        sortable: true,
      },
      {
        name: "Personal Dynamic QrCode Count",
        selector: (row) => row?.dynamicQrCodeCount === -1 ? "Unlimited" : row?.dynamicQrCodeCount,
        sortable: true,
      },
      {
        name: "Personal Dynamic QrCode Count Used",
        selector: (row) => row?.dynamicQrCodeCountUsed,
        sortable: true,
      },

      // {
      //   name: "Action",
      //   cell: (row) => {
      //     return (
      //       <div>
      //         <button
      //           onClick={toggleQrCodeModal}
      //           type="button"
      //           className="btn btn-primary btn-sm mr-2"
      //         >
      //           <i className="ion ion-md-create "></i>
      //         </button>
      //       </div>
      //     );
      //   },
      // },
    ],
    []
  );
  const Pendingpackagecolumns = useMemo(
    () => [
      {
        name: "Sr.no",
        selector: (row, index) => row?.sr,
        sortable: true,
      },
      {
        name: "Package name",
        selector: (row) => (row.packageName ? row.packageName : "N/A"),
        sortable: true,
      },
      {
        name: "Price",
        selector: (row) => row?.price,
        sortable: true,
        style: (row) => ({ display: "block" }),
        cell: (row) => {
          {
            return row?.currencyList?.length > 0 ? (
              row?.currencyList?.map((item, index) => {
                return (
                  <div>
                    <span className="smallroundbuttonrow">
                      <div className="smallroundbutton"></div>
                      <p className="pricebuttontext">
                        {item?.currencyName} {""}
                        {"( "}
                        {item?.currencyOtherName}
                        {item?.price} {" )"}
                      </p>
                    </span>
                  </div>
                );
              })
            ) : (
              <></>
            );
          }
        },
      },
      // {
      //   name: "Monthly Price",
      //   selector: (row) => row.monthlyPrice,
      //   sortable: true,
      // },
      // {
      //   name: "Annually Price",
      //   selector: (row) => row.annuallyPrice,
      //   sortable: true,
      // },
      {
        name: "Pending plan",
        // selector: (row) => (row?.isActive === true ? "Active" : "Deactive") "Pending",
        sortable: false,
        cell: (row) => {
          return (
            <div>
              <span>Pending</span>
            </div>
          );
        },
      },
      // {
      //   name: "Yearly/Monthly",
      //   selector: (row) => (row?.isMonthly === true ? "Monthly" : "Yearly"),
      //   sortable: true,
      // },
      {
        name: "Dynamic QrCode Count",
        selector: (row) =>
          row?.apDynamicQrCodeCount === -1
            ? "Unlimited"
            : row?.apDynamicQrCodeCount,
        sortable: true,
      },
      // {
      //   name: "Dynamic QrCode Count Used",
      //   selector: (row) => row?.apDynamicQrCodeCountUsed,
      //   sortable: true,
      // },
      {
        name: "Bulk QrCode Count",
        selector: (row) =>
          row?.bulkQrCodeCount === -1 ? "Unlimited" : row?.bulkQrCodeCount,
        sortable: true,
      },
      // {
      //   name: "Bulk QrCode Count Used",
      //   selector: (row) => row?.bulkQrCodeCountUsed,
      //   sortable: true,
      // },
      {
        name: "Personal Dynamic QrCode Count",
        selector: (row) =>
          row?.dynamicQrCodeCount === -1
            ? "Unlimited"
            : row?.dynamicQrCodeCount,
        sortable: true,
      },
      // {
      //   name: "Personal Dynamic QrCode Count Used",
      //   selector: (row) => row?.dynamicQrCodeCountUsed,
      //   sortable: true,
      // },

      {
        name: "Action",
        cell: (row) => {
          return (
            <div>
              <button
                onClick={async () => {
                  let checkLogin = row?.userCompanyId;
                  if (checkLogin) {
                    const checkuserlock = await CheckUserIslock(checkLogin);
                    if (checkuserlock === false || checkuserlock === false) {
                      swal(
                        "oops!",
                        "Sorry! You can not do any transaction in 1 hour.",
                        "warning"
                      );
                    }
                    else {
                      togglePendingPackageOpen(row);
                    }
                  }
                }}
                type="button"
                className="btn btn-primary btn-sm mr-2 mb-2 mt-2"
              >
                {/* <i className="ion ion-md-create "></i> */}
                Assign Plan
              </button>

              {/* <button
                onClick={() => {
                  alert("comming soon cancelled Package");
                }}
                type="button"
                className="btn btn-secondary btn-sm mr-2 mb-2"
              >
                <i className="ion ion-md-create "></i>
                Yearly Price
              </button> */}
              <button
                onClick={() => {
                  Deleteuserpendingpackage(row);
                }}
                type="button"
                className="btn btn-danger btn-sm mr-2 mb-2"
              >
                {/* <i className="fa fa-trash "></i> */}
                Delete
              </button>
            </div>
          );
        },
      },
    ],
    []
  );

  const togglePackage = async () => {
    await getfixePackage(IsWeb, true);
    setPackageModalisOpen(true);
  };

  const SelectSystemmonthlyPackage = (e) => {
    setCurrencyPriceID("");
    setCurrencyPriceError("");
    setCurrencyPricelist([]);
    let item = SystemPackagemonthlyList.find((x) => x._id === e.target.value);
    if (item !== null && item !== undefined && item !== "" && UserPackageInfo) {
      const currencylist = item?.currencyList
      if (UserPackageInfo?.isActive) {
        let ActivePackagecurrencyID = UserPackageInfo?.currencyID;
        const Activecurrency = currencylist.filter(x => x.currencyID === ActivePackagecurrencyID);
        if (Activecurrency) {
          OnsetCurrencyPricelist(Activecurrency);
        }
        else {
          setCurrencyPricelist([]);
        }
      }
      else {
        OnsetCurrencyPricelist(item?.currencyList);
      }

    } else {
      setCurrencyPricelist([]);
    }
    setMonthlyselectsubscribedpackage(e.target.value);
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      setisPackageDetailShow(true);
      setPackageDetailitem(item);
    }
    else {
      setisPackageDetailShow(false);
      setPackageDetailitem(null);
    }
  };
  const SelectSystemYearlyPackage = (e) => {
    setCurrencyPriceError("");
    setCurrencyPriceID("");
    setCurrencyPriceError("");
    setCurrencyPricelist([]);

    let item = SystemPackageannuallyList.find((x) => x._id === e.target.value);
    if (item !== null && item !== undefined && item !== "" && UserPackageInfo) {
      const currencylist = item?.currencyList
      if (UserPackageInfo?.isActive) {
        let ActivePackagecurrencyID = UserPackageInfo?.currencyID;
        const Activecurrency = currencylist.filter(x => x.currencyID === ActivePackagecurrencyID);
        if (Activecurrency) {
          OnsetCurrencyPricelist(Activecurrency);
        }
        else {
          setCurrencyPricelist([]);
        }
      }
      else {
        OnsetCurrencyPricelist(item?.currencyList);
      }

    } else {
      setCurrencyPricelist([]);
    }
    // if (item !== null && item !== undefined && item !== "") {
    //   OnsetCurrencyPricelist(item?.currencyList);
    // } else {
    //   setCurrencyPricelist([]);
    // }
    setYearlyselectsubscribedpackage(e.target.value);
    if (e.target.value !== null && e.target.value !== "" && e.target.value !== undefined) {
      setisPackageDetailShow(true);
      setPackageDetailitem(item);
    }
    else {
      setisPackageDetailShow(false);
      setPackageDetailitem(null);
    }
  };

  const togglePackageclose = () => {
    setisPaymentshow(false);
    setMonthlyselectsubscribedpackage("");
    setYearlyselectsubscribedpackage("");
    setCvv("");
    setExpiry("");
    settotalPrice("");
    setNumber("");
    setautorenewal(false);
    setisMonthly(true);
    setisYearly(false);
    setiscash(true);
    setCurrencyPriceError("");
    setCurrencyPriceID("");
    setPackageModalisOpen(false);
    setisPackageDetailShow(false);
    setPackageDetailitem(null);
  };

  const togglePendingPackageOpen = async (rowitem) => {
    try {
      if (
        rowitem?.systemPackageId !== null &&
        rowitem?.systemPackageId !== "" &&
        rowitem?.systemPackageId !== undefined
      ) {
        let response = await GetPackageDetailWithCurrencyListBySuperadmin(rowitem?.systemPackageId);

        let data = await getUsrActivePackageDetailByuserid(rowitem?.userCompanyId);
        if (data?._id !== null && data?._id !== "" && data?._id !== undefined) {
          console.log("data User===>", data);
          setUserPackageInfo(data)
          if (data?.isActive) {
            let ActivePackagecurrencyID = data?.currencyID;
            const Activecurrency = response?.currencyList.filter(x => x.currencyID === ActivePackagecurrencyID);
            if (Activecurrency) {
              OnsetCurrencyPricelist(Activecurrency);
              setAssignCurrencyPricelist(
                Activecurrency
              );
            }
            else {
              setAssignCurrencyPricelist([]);
            }
          }
          else {
            setAssignCurrencyPricelist(
              response?.currencyList ? response?.currencyList : []
            );
          }
        }
        else {
          setAssignCurrencyPricelist(
            response?.currencyList ? response?.currencyList : []
          );
        }

        setselectpendingPackage(rowitem);
        setisPaymentshow(false);
        settotalPrice("");
        setautorenewal(true);
        setiscash(true);
        setisMonthly(true);
        setisYearly(false);
        setPendingPackageModalisOpen(true);
      }
    } catch (error) {
      console.log("error====>", error);
    }
  };
  const togglePendingPackageclose = () => {
    setselectpendingPackage(null);
    setisPaymentshow(false);
    setCvv("");
    setExpiry("");
    settotalPrice("");
    setNumber("");
    setautorenewal(false);
    setisMonthly(true);
    setisYearly(false);
    setiscash(true);
    setAssignCurrencyPriceID("");
    setCurrencyPriceError("");
    setPendingPackageModalisOpen(false);

  };
  const Proceedpackage = async () => {
    setCurrencyPriceError("");
    let packageinfo = null;
    if (isMonthly === true) {
      packageinfo = SystemPackagemonthlyList.find(
        (x) => x._id === monthlyselectsubscribedpackage
      );
    } else {
      packageinfo = SystemPackageannuallyList.find(
        (x) => x._id === Yearlyselectsubscribedpackage
      );
    }
    if (packageinfo !== null && packageinfo !== undefined) {
      if (
        CurrencyPriceID !== null &&
        CurrencyPriceID !== "" &&
        CurrencyPriceID !== undefined
      ) {
        let selectCurrencyitem = CurrencyPricelist.find(
          (x) => x.value === CurrencyPriceID
        );
        if (selectCurrencyitem !== null) {
          settotalPrice(
            selectCurrencyitem?.otherName + selectCurrencyitem?.priceValue
          );
        } else {
          return true;
        }
      } else {
        setCurrencyPriceError("please select package price");
        return true;
      }
      // setisPaymentshow(true);
      let checkLogin = localStorage.getItem("loginUserID");
      let userid = userRef.current?._id;
      if (packageinfo && packageinfo?._id && userid) {
        let ischeckupdateornot = await IsCheckUserPackageUpgradeOrNot(packageinfo?._id, userid, CurrencyPriceID , isstripePay);
        if (ischeckupdateornot === true) {
          setisPaymentshow(true);
        }
        else {
          swal("Please adjust your current package with your previous one. Click this link to review and make the necessary adjustments.");
        }
      }
    } else {
      setSelectedPackageError("please select package");
      return true;
    }
  };

  const ProceedPendingpackage = async () => {
    if (
      AssignCurrencyPriceID !== null &&
      AssignCurrencyPriceID !== "" &&
      AssignCurrencyPriceID !== undefined
    ) {
      let selectCurrencyitem = AssignCurrencyPricelist.find(
        (x) => x.value === AssignCurrencyPriceID
      );
      if (selectCurrencyitem !== null) {
        settotalPrice(
          selectCurrencyitem?.otherName + selectCurrencyitem?.priceValue
        );

        let userid = userRef.current?._id;
        let packageinfo = selectpendingPackage;
        if (packageinfo && packageinfo?.systemPackageId && userid) {
          let ischeckupdateornot = await IsCheckUserPackageUpgradeOrNot(packageinfo?.systemPackageId, userid, AssignCurrencyPriceID , isstripePay);
          if (ischeckupdateornot === true) {
            setisPaymentshow(true);
          }
          else {
            swal("Please adjust your current package with your previous one. Click this link to review and make the necessary adjustments.")
          }
        }
        // setisPaymentshow(true);
      } else {
        return true;
      }
    } else {
      setCurrencyPriceError("please select package price");
      return true;
    }
    // let packageinfo = selectpendingPackage;
    // if (packageinfo !== null && packageinfo !== undefined) {
    //   if (isMonthly === true) {
    //     settotalPrice(packageinfo?.monthlyPrice);
    //   } else {
    //     settotalPrice(packageinfo?.annuallyPrice);
    //   }
    //   setisPaymentshow(true);
    // } else {
    //   alert("select package");
    // }
  };

  const CustomPackagelinksend = async (userid, packagepaymentuid, assigncurrencypriceID) => {
    try {
      if (userid && packagepaymentuid) {
        setloadingsendPayment(true);
        const response = await sendPaymentlink(userid, packagepaymentuid, assigncurrencypriceID);
        if (response != null && response === true) {
          setloadingsendPayment(false);
          togglePendingPackageclose();
          swal("Congratulations! Your payment link successfully send.", {
            icon: "success",
          });
        }
        else {
          setloadingsendPayment(false);
          swal("Sorry! Your payment link not send.", {
            icon: "error",
          });
        }
      }

    } catch (error) {
      setloadingsendPayment(false);
      swal("Sorry! Your payment link not send.", {
        icon: "error",
      });
    }
  }

  const Cashcreatepackage = async () => {
    let checkLogin = localStorage.getItem("loginUserID");

    setisLoading(true);
    let packagemodel = {
      systemPackageId:
        isMonthly === true
          ? monthlyselectsubscribedpackage
          : Yearlyselectsubscribedpackage,
      userCompanyID: userRef.current?._id,
      IsMonthly: isMonthly,
      paymentStatus: "Paid",
      createdBy: checkLogin,
      updatedBy: checkLogin,
      stripeSubscriptionId: "",
      Isautorenewal: autorenewal,
      type: "Cash",
      cardnumber: "",
      cardexp_month: null,
      cardexp_year: null,
      cardcvc: "",
      IsCash: true,
      SystemPackagePriceId: CurrencyPriceID,
    };
    let response = await CashUserPackageCreate(JSON.stringify(packagemodel));
    if (response?.responseType === "Success") {
      // getAllUserWithSystemPackageDetail();
      getAllUserWithSystemPackageDetailWithSearching("", "", "", "");
      getUserWithSystemPackageDetail(userRef.current?._id);
      togglePackageclose();
      setisLoading(false);
      swal("Congratulations! Your data successfully update.", {
        icon: "success",
      });
    } else {
      setisLoading(false);
      swal("Sorry! Your data not update.", {
        icon: "error",
      });
    }
    // let packageinfo = null;
    // if (isMonthly === true) {
    //   packageinfo = SystemPackageList.find(
    //     (x) => x._id === monthlyselectsubscribedpackage
    //   );
    // } else {
    //   packageinfo = SystemPackageList.find(
    //     (x) => x._id === Yearlyselectsubscribedpackage
    //   );
    // }
    // if (packageinfo !== null && packageinfo !== undefined) {

    // } else {
    //   setisLoading(false);
    //   swal("please select package");
    //   console.log("package not found");
    // }
  };
 

  const CashcreatePendingpackage = async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    let packageinfo = selectpendingPackage;
    if (
      AssignCurrencyPriceID === null ||
      AssignCurrencyPriceID === "" ||
      AssignCurrencyPriceID === undefined
    ) {
      return true;
    }
    if (packageinfo !== null && packageinfo !== undefined) {
      setisLoading(true);
      let packagemodel = {
        systemPackageId: packageinfo?.systemPackageId,
        userCompanyID: userRef.current?._id,
        IsMonthly: packageinfo?.isMonthly,
        paymentStatus: "Paid",
        createdBy: checkLogin,
        updatedBy: checkLogin,
        stripeSubscriptionId: "",
        Isautorenewal: autorenewal,
        type: "Cash",
        cardnumber: "",
        cardexp_month: null,
        cardexp_year: null,
        cardcvc: "",
        IsCash: true,
        UserPackagePaymentID: selectpendingPackage?.userPackagePaymentID,
        SystemPackagePriceId: AssignCurrencyPriceID,
      };
      let response = await CashUserPendingPackageCreate(
        JSON.stringify(packagemodel)
      );
      if (response?.responseType === "Success") {
        //getAllUserWithSystemPackageDetail();
        getAllUserWithSystemPackageDetailWithSearching("", "", "", "");
        getUserWithSystemPackageDetail(userRef.current?._id);
        togglePendingPackageclose();
        setisLoading(false);
        swal("Congratulations! Your data successfully update.", {
          icon: "success",
        });
      } else {
        setisLoading(false);
        swal("Sorry! Your data not update.", {
          icon: "error",
        });
      }
    } else {
      setisLoading(false);
      swal("please select package");
      console.log("package not found");
    }
  };
 
  const submitSystempackage = async () => {
    let loginid = localStorage.getItem("loginUserID");
    if (
      packagename === null ||
      packagename === "" ||
      packagename === undefined
    ) {
      setpackagenameError("Please Enter Package Name");
      return true;
    }
    if (
      selectpackageCategory === null ||
      selectpackageCategory === "" ||
      selectpackageCategory === undefined
    ) {
      setselectpackageCategoryError("Please Select Category");
      return true;
    }
    if (isusercase === false) {
      if (
        selectedOption === null ||
        selectedOption === "" ||
        selectedOption === undefined
      ) {
        setSelectedOptionError("Please Select Currency");
        return true;
      } else {
        if (selectedcurrency.length > 0) {
          let tempselectedcurrency = [...selectedcurrency];
          let temp = tempselectedcurrency.find(
            (x) =>
              x.priceValue === "" ||
              x.priceValue === null ||
              x.priceValue === undefined
          );
          if (temp !== null && temp !== "" && temp !== undefined) {
            let index = tempselectedcurrency.findIndex(
              (obj) => obj?.value === temp?.value
            );
            tempselectedcurrency[index].priceValueError = "Please Enter Price";
            setSelectedcurrency(tempselectedcurrency);
            return true;
          }
        } else {
          setSelectedOptionError("Please Select Currency");
          return true;
        }
      }
    } else {
      if (
        selectedOptionIscash === null ||
        selectedOptionIscash === "" ||
        selectedOptionIscash === undefined
      ) {
        setSelectedOptionError("Please Select Currency");
        return true;
      } else {
        if (selectedcurrencyCash.length > 0) {
          let tempselectedcurrency = [...selectedcurrencyCash];
          let temp = tempselectedcurrency.find(
            (x) =>
              x.priceValue === "" ||
              x.priceValue === null ||
              x.priceValue === undefined
          );
          if (temp !== null && temp !== "" && temp !== undefined) {
            let index = tempselectedcurrency.findIndex(
              (obj) => obj?.value === temp?.value
            );
            tempselectedcurrency[index].priceValueError = "Please Enter Price";
            setSelectedcurrencyCash(tempselectedcurrency);
            return true;
          }
        } else {
          setSelectedOptionError("Please Select Currency");
          return true;
        }
      }
    }

    let finalcurrencylist = [];
    if (isusercase === false) {
      let tempselectedcurrency = [...selectedcurrency];
      if (tempselectedcurrency) {
        tempselectedcurrency.map((item) => {
          let CurrencyPriceDto = {
            CurrencyID: item?.value,
            Price: item?.priceValue,
          };
          finalcurrencylist.push(CurrencyPriceDto);
        });
      }
    } else {
      let tempselectedcurrency = [...selectedcurrencyCash];

      if (tempselectedcurrency) {
        tempselectedcurrency.map((item) => {
          let CurrencyPriceDto = {
            CurrencyID: item?.value,
            Price: item?.priceValue,
          };
          finalcurrencylist.push(CurrencyPriceDto);
        });
      }
    }
    if (finalcurrencylist.length === 0) {
      return;
    }
    setloadingCreateCustomisedPackage(true);
    let bytes = "";
    if (dataStorageCount) {
      let Intvalue = parseFloat(dataStorageCount);
      bytes = parseFloat((Intvalue) * 1000000000).toFixed(0);
    }
    let body = {
      _id: SystempackageID,
      categoryId: selectpackageCategory,
      packageName: packagename,
      isCustom: IsCustom,
      isWeb: IsWeb,
      isAutoRenewal: AutoRenewal,
      articalSavingCount: dynamicQrCodeCount ? dynamicQrCodeCount : "-1",
      apDynamicQrCodeCount: dynamicQrCodeCount ? dynamicQrCodeCount : "-1",
      bulkQrCodeCount: bulkQrCodeCount ? bulkQrCodeCount : "-1",
      dynamicQrCodeCount: personaldynamicQrCodeCount
        ? personaldynamicQrCodeCount
        : "-1",
      staticQrCodeCount: staticCodeCount ? staticCodeCount : "-1",
      dataStorageCount: dataStorageCount ? bytes : "-1",
      monthlyScanCount: monthlyCodeCount ? monthlyCodeCount : "-1",
      subAccountCount: subaccountCount ? subaccountCount : "-1",
      noOfChatUser: noofchatuserCount ? noofchatuserCount : "-1",
      isChatEnabled: IsWeb ? ChatEnabled : false,
      isSSLCertificate: IsWeb ? SSLCertificate : false,
      isAdvanceQrCodeSearch: IsWeb ? AdvanceQrCodeSearch : false,
      isQrCodeSaveInWallet: IsWeb ? QrCodeSaveInWallet : false,
      isQrCodeCategoryManaged: IsWeb ? QrCodeCategoryManaged : false,
      isExportQrCode: IsWeb ? ExportQrCode : false,
      isEmailSupport: IsWeb ? EmailSupport : false,
      isIndividualSupport: IsWeb ? IndividualSupport : false,
      isIndividualPhoneSupport: IsWeb ? IndividualPhoneSupport : false,
      isWhiteLabelling: IsWeb ? WhiteLabelling : false,
      isYourBranding: IsWeb ? YourBranding : false,
      createdBy: loginid,
      updatedBy: loginid,
      UserID: userRef.current?._id,
      PackagePriceList: finalcurrencylist,
      IsMonthly: IsMonthly,

    };

    console.log("body", JSON.stringify(body));
    let response = await CreateUserCustomPackage(JSON.stringify(body));
    if (
      response?._id !== null &&
      response?._id !== "" &&
      response?._id !== null
    ) {
      setloadingCreateCustomisedPackage(false);
      getUserWithSystemPackageDetail(userRef.current?._id);
      systempackageclere();
      setpackageaddeditmodalopen(false);
      swal("successfully", "create package successfully.", "success");
    } else {
      setloadingCreateCustomisedPackage(false);
      swal("sorry!", "package not create.", "error");
    }
  };

  const systempackageclere = () => {
    setSystempackageID("");
    setselectpackageCategory("");
    setpackagename("");
    setIsCustom(true);
    setAutoRenewal(true);
    setDynamicQrCodeCount("");
    setbulkQrCodeCount("");
    setPersonaldynamicQrCodeCount("");
    setStaticCodeCount("");
    setDataStorageCount("");
    setMonthlyCodeCount("");
    setSubaccountCount("");
    setChatEnabled(true);
    setNoofchatuserCount("");
    setSSLCertificate(true);
    setAdvanceQrCodeSearch(true);
    setQrCodeSaveInWallet(true);
    setQrCodeCategoryManaged(true);
    setExportQrCode(true);
    setEmailSupport(true);
    setIndividualSupport(true);
    setIndividualPhoneSupport(true);
    setWhiteLabelling(true);
    setYourBranding(true);
    setSelectedcurrencyCash([]);
    setSelectedcurrency([]);
    setSelectedOption(null);
    setSelectedOptionCash(null);
    setiscash(false);
    setUserCase(false);
  };

  const toggleAddPackageModal = () => {
    togglePackageclose();
    systempackageclere();
    setpackageaddeditmodalopen(!packageaddeditmodalopen);
  };

  const Cancelyoursubscription = () => {
    swal({
      title: "Are you sure?",
      text: "Once cancel, you will not be able to recover this package !",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        if (userRef?.current?._id) {
          let response = await UserPackagecancelbysupperadmin(
            userRef.current?._id
          );
          if (response && userRef?.current?._id) {
            //getAllUserWithSystemPackageDetail();
            getAllUserWithSystemPackageDetailWithSearching("", "", "", "");
            getUserWithSystemPackageDetail(userRef?.current?._id);
          }
        }
      }
    });
  };

  const Deleteuserpendingpackage = (rowitem) => {
    if (rowitem?.userPackagePaymentID) {
      swal({
        title: "Are you sure?",
        text: "Once delete, you will not be able to recover this package !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          let response = await Deleteuserpendingpackagebysupperadmin(
            rowitem?.userPackagePaymentID
          );
          if (response && response?.responseType === "Success") {
            if (userRef.current?._id) {
              getUserWithSystemPackageDetail(userRef.current?._id);
            }
          }
        }
      });
    }
  };
  const toggleUserpackageinfoModal = () => {
    Packageinforef.current = null;
    setUsersassignedpackageinfoIsshow(false);
  };

  const bytesToSize = (bytes) => {
    if (bytes !== null && bytes !== "" && bytes !== undefined) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return 0;
      // var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)));
      if (i == 0) return bytes + " " + sizes[i];
      return (bytes / Math.pow(1000, i)).toFixed(2) + " " + sizes[i];
    } else {
      return "N/A";
    }
  };

  const bytesToSizeRemaining = (Packeagebytes, usedbyte) => {
    if (
      Packeagebytes !== null &&
      Packeagebytes !== undefined &&
      Packeagebytes !== "" &&
      usedbyte !== null &&
      usedbyte !== undefined &&
      usedbyte !== ""
    ) {
      let bytes = parseFloat(Packeagebytes - usedbyte);
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return 0;
      // var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1000)));
      if (i == 0) return bytes + " " + sizes[i];
      return (bytes / Math.pow(1000, i)).toFixed(2) + " " + sizes[i];
    } else {
      return "N/A";
    }
  };
  const onChangecurrency = (item) => {
    let olddata = [...selectedcurrency];
    if (item?.action === "select-option") {
      item.option.priceValue = "";
      olddata.push(item?.option);
      setSelectedcurrency(olddata);
    } else if (item?.action === "remove-value") {
      let data = olddata.filter((x) => x.value !== item?.removedValue?.value);
      setSelectedcurrency(data);
    } else if (item?.action === "clear") {
      setSelectedcurrency([]);
    }
  };
  const createCurrencyUI = () => {
    if (
      selectedcurrency !== null &&
      selectedcurrency !== "" &&
      selectedcurrency !== undefined &&
      selectedcurrency.length > 0
    ) {
      return selectedcurrency.map((el, i) => {
        return (
          <>
            <div
              className={
                selectedcurrency.length === 1
                  ? "col-xl-12 col-lg-12 mt-2"
                  : selectedcurrency.length === 2
                    ? "col-xl-6 col-lg-6 mt-2"
                    : "col-xl-4 col-lg-4 mt-2"
              }
            >
              <label htmlFor="exampleInputEmail1">
                <h5 className="mb-0">
                  {el?.label} {"(" + el?.otherName + ")"}
                </h5>
              </label>
              <NumericFormat
                thousandSeparator={true}
                className="form-control mb-2"
                placeholder={`${el?.label} Price`}
                decimalScale={2}
                fixedDecimalScale={false}
                value={el?.priceValue}
                onValueChange={OnchangedPrice(i)}
              />
              {el?.priceValueError?.length > 0 ? (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {el?.priceValueError}
                </span>
              ) : (
                <></>
              )}
            </div>
          </>
        );
      });
    }
  };
  const OnchangedPrice = (i) => (e) => {
    if (
      selectedcurrency !== null &&
      selectedcurrency !== "" &&
      selectedcurrency !== undefined
    ) {
      let selectedcurrencyTemp = [...selectedcurrency];
      selectedcurrencyTemp[i].priceValue = e.floatValue;
      selectedcurrencyTemp[i].priceValueError = "";
      setSelectedcurrency(selectedcurrencyTemp);
    }
  };

  const onChangecurrencyCash = (item) => {
    if (item !== null && item !== "" && item !== undefined) {
      let templist = [];
      item.priceValue = "";
      templist.push(item);
      setSelectedcurrencyCash(templist);
    } else {
      setSelectedcurrencyCash([]);
    }
  };
  const createCurrencyUICash = () => {
    if (
      selectedcurrencyCash !== null &&
      selectedcurrencyCash !== "" &&
      selectedcurrencyCash !== undefined &&
      selectedcurrencyCash.length > 0
    ) {
      return selectedcurrencyCash.map((el, i) => {
        return (
          <>
            <div
              className={
                selectedcurrencyCash.length === 1
                  ? "col-xl-12 col-lg-12 mt-2"
                  : selectedcurrencyCash.length === 2
                    ? "col-xl-6 col-lg-6 mt-2"
                    : "col-xl-4 col-lg-4 mt-2"
              }
            >
              <label htmlFor="exampleInputEmail1">
                <h5 className="mb-0">
                  {el?.label} {"(" + el?.otherName + ")"}
                </h5>
              </label>
              <NumericFormat
                thousandSeparator={true}
                className="form-control mb-2"
                placeholder={`${el?.label} Price`}
                decimalScale={2}
                fixedDecimalScale={false}
                value={el?.priceValue}
                onValueChange={OnchangedPriceCash(i)}
              />
              {el?.priceValueError?.length > 0 ? (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {el?.priceValueError}
                </span>
              ) : (
                <></>
              )}
            </div>
          </>
        );
      });
    }
  };
  const OnchangedPriceCash = (i) => (e) => {
    if (
      selectedcurrencyCash !== null &&
      selectedcurrencyCash !== "" &&
      selectedcurrencyCash !== undefined
    ) {
      let selectedOptionTemp = [...selectedcurrencyCash];
      selectedOptionTemp[i].priceValue = e.floatValue;
      selectedOptionTemp[i].priceValueError = "";
      setSelectedcurrencyCash(selectedOptionTemp);
    }
  };

  const OnchnagesetCurrencyList = (value) => {
    setSelectedOption(null);
    setSelectedOptionCash(null);
    setSelectedcurrency([]);
    setSelectedcurrencyCash([]);
    setTimeout(() => {
      setUserCase(!value);
    }, 300);
  };

  const OnsetCurrencyPricelist = (item) => {
    if (item !== null && item !== undefined && item !== "") {
      setCurrencyPricelist(item);
    } else {
      setCurrencyPricelist([]);
    }
  };
  return (
    <div>
      <LoaderSpinner
        isrefresh={loading || Allloading || userloading || Detailisloading || loadingCreateCustomisedPackage || loadingsendPayment}
      />
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <a href="/home">Home</a>
          </li>
          <li className="breadcrumb-item active">User</li>
        </ol>
        <h1 className="page-header">Users</h1>
        <Panel>
          <PanelHeader>
            <div>
              <h4 className="mb-0 text-light">
                <i className="fas fa-fw m-r-10 fa-search"></i> Search
              </h4>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="row mt-2">
              <div className="col-xl-6 px-4">
                <form action="javascript:void(0);" method="POST">
                  <fieldset>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Email{" "}
                      </label>
                      <div className="col-md-7">
                        <input
                          type="text"
                          className="form-control input-height"
                          placeholder="Enter Email"
                          value={searchEmail}
                          onChange={(e) => {
                            setsearchEmail(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Name{" "}
                      </label>
                      <div className="col-md-7">
                        <input
                          type="text"
                          className="form-control input-height"
                          placeholder="Enter Name"
                          value={searchName}
                          onChange={(e) => {
                            setsearchName(e.target.value);
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label product-lable">
                        Operating system{" "}
                      </label>
                      <div className="col-md-7">
                        <select
                          className="default-select2 form-control"
                          value={searchOS}
                          onChange={(e) => {
                            setsearchOS(e.target.value);
                          }}
                        >
                          <option value="" selected>
                            --- Select Operating System ---
                          </option>
                          <option value="true">Web</option>
                          <option value="false">Mobile</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group row m-b-15 d-flex align-items-center">
                      <label className="col-md-4 col-form-label  product-lable">
                        Active package{" "}
                      </label>
                      <div className="col-md-7">
                        <select
                          className="default-select2  form-control"
                          value={searchPackageID}
                          onChange={(e) => setsearchPackageID(e.target.value)}
                        >
                          <option value="" selected>
                            --- Select Active Package ---
                          </option>
                          {searchSystemPackageList?.map((item, i) => (
                            <option key={i} value={item?._id}>
                              {item?.packageName}{" "}
                              {item?.isWeb === false ? "(Moblile)" : "(Web)"}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </fieldset>
                </form>
              </div>
            </div>
            <div className="row  justify-content-center">
              <button
                type="button"
                className="btn btn-primary search-btn d-flex align-items-center mr-2"
                onClick={() => {
                  if (
                    (searchEmail !== "" &&
                      searchEmail !== undefined &&
                      searchEmail !== undefined) ||
                    (searchName !== "" &&
                      searchName !== undefined &&
                      searchName !== undefined) ||
                    (searchOS !== "" &&
                      searchOS !== undefined &&
                      searchOS !== undefined) ||
                    (searchPackageID !== "" &&
                      searchPackageID !== undefined &&
                      searchPackageID !== undefined)
                  ) {
                    getAllUserWithSystemPackageDetailWithSearching(
                      searchEmail,
                      searchName,
                      searchOS,
                      searchPackageID
                    );
                  } else {
                    getAllUserWithSystemPackageDetailWithSearching(
                      "",
                      "",
                      "",
                      ""
                    );
                  }
                }}
              >
                <i className="fas fa-lg fa-fw m-r-10 fa-search "></i>
                Search
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={(e) => {
                  //ClereHedersearch(e);
                  setsearchEmail("");
                  setsearchName("");
                  setsearchOS("");
                  setsearchPackageID("");
                  getAllUserWithSystemPackageDetailWithSearching(
                    "",
                    "",
                    "",
                    ""
                  );
                }}
              >
                Reset
              </button>
            </div>
          </PanelBody>
        </Panel>
        <Panel className="mt-2">
          <PanelHeader>
            <div className="d-md-flex align-items-center">
              <h4 className="mb-0 text-light">User list</h4>
            </div>
          </PanelHeader>
          <PanelBody>
            <DataTable
              pagination
              data={userDetail}
              columns={usercolumns}
              sortIcon={
                <i className="fa fa-sort-down fa-fw f-s-14 text-blue"></i>
              }
              // selectableRows
              onSelectedRowsChange={handleChangeUser}
            />
          </PanelBody>
        </Panel>
      </div>
      <Modal
        isOpen={userdetailmadalOpen}
        toggle={userdetailmadalOpen}
        className="modal-xl"
      >
        <ModalHeader toggle={toggleQrCodeModal} className="modalheader">
          <h4 className="text-white mb-0">User detail</h4>
        </ModalHeader>
        <ModalBody>
          <div className="row px-3">
            <div className="col-xl-6">
              <div className="row  align-items-center mb-4">
                <div className="col-xl-6">
                  {userinfo?.image !== null ? (
                    <img
                      src={Config.contentUrl + userinfo?.image}
                      className="rounded qrcode-article-image"
                    ></img>
                  ) : (
                    <img
                      src="../assets/img/new-images/images.png"
                      className="rounded qrcode-article-image"
                    />
                  )}
                </div>
                <div className="col-xl-6">
                  <div className="row">
                    <h5 className="col-xl-5 mb-0">
                      <b>Email</b>
                    </h5>
                    <p>:</p>
                    <p className="col-xl-6">
                      {userinfo?.email ? userinfo?.email : "N/A"}
                    </p>
                  </div>
                  <div className="row">
                    <h5 className="col-xl-5 mb-3">
                      <b>Name</b>
                    </h5>
                    <p>:</p>
                    <p className="col-xl-6">
                      {userinfo?.name ? userinfo?.name : "N/A"}
                    </p>
                  </div>

                  {/* <div className="row">
                    <h5 className="col-xl-5 mb-0">
                      <b>Phone no</b>
                    </h5>
                    <p>:</p>
                    <p className="col-xl-6">
                      {userinfo?.phoneNumber ? userinfo?.phoneNumber : "N/A"}
                    </p>
                  </div> */}
                  <div className="row">
                    <h5 className="col-xl-5 mb-0">
                      <b>Active plan</b>
                    </h5>
                    <p>:</p>
                    <p className="col-xl-6">
                      {activeplan ? activeplan : "N/A"}
                    </p>
                  </div>
                  <div className="mt-2 my-xl-0 ">
                    <div className="row">
                      <button
                        type="button"
                        className="btn  btn-primary m-r-5 shadow-add"
                        onClick={async () => {
                          let checkLogin = userRef?.current?._id;
                          if (checkLogin) {
                            const checkuserlock = await CheckUserIslock(checkLogin);
                            if (checkuserlock === false || checkuserlock === false) {
                              swal(
                                "oops!",
                                "Sorry! You can not do any transaction in 1 hour.",
                                "warning"
                              );
                            } else {
                              togglePackage();
                            }
                          }
                        }
                        }
                      >
                        Assign plan
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h4 className="text-black mb-3">Package List</h4>
          {userinfo !== null && userinfo !== "" && userinfo !== undefined ? (
            <>
              <Nav className="mb-3 report-header-tab" pills>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activePill === "1" })}
                    onClick={() => {
                      togglePill("1");
                    }}
                  >
                    <span className="d-sm-none">Active package</span>
                    <span className="d-sm-block d-none">Active package</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activePill === "2" })}
                    onClick={() => {
                      togglePill("2");
                    }}
                  >
                    <span className="d-sm-none">Previous package</span>
                    <span className="d-sm-block d-none">Previous package</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activePill === "3" })}
                    onClick={() => {
                      togglePill("3");
                    }}
                  >
                    <span className="d-sm-none">Pending package</span>
                    <span className="d-sm-block d-none">Pending package</span>
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent className="p-15 rounded  mb-4" activeTab={activePill}>
                <TabPane tabId="1">
                  {/* <h5>Active package</h5> */}
                  <DataTable
                    pagination
                    data={userActivePackageList}
                    columns={Activepackagecolumns}
                    // selectableRows
                    onSelectedRowsChange={handleChangeActive}
                  />
                </TabPane>
                <TabPane tabId="2">
                  {/* <h5>Previous package</h5> */}
                  <DataTable
                    pagination
                    data={userPreviousPackageList}
                    columns={Prevpackagecolumns}
                    // selectableRows
                    onSelectedRowsChange={handleChangePrev}
                  />
                </TabPane>
                <TabPane tabId="3">
                  {/* <h5>Pending package</h5> */}
                  <DataTable
                    pagination
                    data={userPendingPackageList}
                    columns={Pendingpackagecolumns}
                    // selectableRows
                    onSelectedRowsChange={handleChangePending}
                  />
                </TabPane>
              </TabContent>

              {/* <DataTable
                pagination
                data={userpackagelist}
                columns={packagecolumns}
                selectableRows
                onSelectedRowsChange={handleChange}
              /> */}
            </>
          ) : (
            <></>
          )}
        </ModalBody>
      </Modal>

      <Modal
        isOpen={PackageModalisOpen}
        toggle={PackageModalisOpen}
        className="modal-size"
      >
        <ModalHeader toggle={togglePackageclose} className="modalheader">
          <h4 className="text-white mb-0">Change your package</h4>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-xl-4 col-lg-4">
              <div className="mt-2">
                <input
                  type="checkbox"
                  value=""
                  disabled={isPaymentshow}
                  id="isMonthly"
                  checked={isMonthly}
                  onChange={async (e) => {
                    await getfixePackage(IsWeb, true);
                    setMonthlyselectsubscribedpackage("");
                    setYearlyselectsubscribedpackage("");
                    setisPackageDetailShow(false);
                    setPackageDetailitem(null);
                    setisYearly(false);
                    setisMonthly(true);
                  }}
                />
                <label htmlFor="isMonthly" className="ml-2">
                  {" "}
                  Monthly
                </label>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4">
              <div className="mt-2">
                <input
                  type="checkbox"
                  value=""
                  disabled={isPaymentshow}
                  id="isYearly"
                  checked={isYearly}
                  onChange={async (e) => {
                    await getfixePackage(IsWeb, false);
                    setisPackageDetailShow(false);
                    setPackageDetailitem(null);
                    setMonthlyselectsubscribedpackage("");
                    setYearlyselectsubscribedpackage("");
                    setisYearly(true);
                    setisMonthly(false);
                  }}
                />
                <label htmlFor="isYearly" className="ml-2">
                  {" "}
                  Yearly
                </label>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 m-b-5">
              <button
                type="button"
                className="btn  btn-primary m-r-5 shadow-add"
                onClick={toggleAddPackageModal}
              >
                Add User Custom package
              </button>
            </div>
          </div>
          <div className="form-group row m-b-10 flex-wrap">
            <label className="col-md-4 col-form-label" htmlFor="autorenewal">
              Your subscribed package
            </label>
            <div className="searchForm col-md-8">
              {isYearly === true ? (
                <>
                  <select
                    disabled={isPaymentshow}
                    className="default-select2 form-control"
                    onChange={(e) => {
                      SelectSystemYearlyPackage(e);
                    }}
                  >
                    <option
                      value={""}
                      selected={Yearlyselectsubscribedpackage === ""}
                    >
                      {"--- select yearly package ---"}
                    </option>
                    {SystemPackageannuallyList?.map((item) => {
                      return (
                        <option
                          value={item?._id}
                          selected={Yearlyselectsubscribedpackage === item?._id}
                        >
                          {item?.packageName}
                        </option>
                      );
                    })}
                  </select>
                  {SelectedPackageError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {SelectedPackageError}
                    </span>
                  )}
                </>
              ) : (
                <>
                  <select
                    disabled={isPaymentshow}
                    className="default-select2 form-control"
                    onChange={(e) => {
                      setSelectedPackageError("")
                      SelectSystemmonthlyPackage(e);
                    }}
                  >
                    <option
                      value={""}
                      selected={monthlyselectsubscribedpackage === ""}
                    >
                      {"--- select monthly package ---"}
                    </option>
                    {SystemPackagemonthlyList?.map((item) => {
                      return (
                        <option
                          value={item?._id}
                          selected={
                            monthlyselectsubscribedpackage === item?._id
                          }
                        >
                          {item?.packageName}
                        </option>
                      );
                    })}
                  </select>
                  {SelectedPackageError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {SelectedPackageError}
                    </span>
                  )}
                </>
              )}
            </div>
            {(Yearlyselectsubscribedpackage !== null &&
              Yearlyselectsubscribedpackage !== undefined &&
              Yearlyselectsubscribedpackage !== "") ||
              (monthlyselectsubscribedpackage !== null &&
                monthlyselectsubscribedpackage !== "" &&
                monthlyselectsubscribedpackage !== undefined) ? (
              <>
                <label
                  className="col-md-4 col-form-label"
                // htmlFor="autorenewal"
                >
                  Package Price
                </label>
                <div className="searchForm col-md-8">
                  <select
                    disabled={isPaymentshow}
                    className="default-select2 form-control"
                    onChange={(e) => {
                      setCurrencyPriceError("");
                      setCurrencyPriceID(e.target.value);
                      //SelectSystemYearlyPackage(e);
                    }}
                  >
                    <option
                      value={""}
                      selected={Yearlyselectsubscribedpackage === ""}
                    >
                      {"--- select package price ---"}
                    </option>
                    {CurrencyPricelist?.map((item) => {
                      return (
                        <option
                          value={item?.value}
                          selected={CurrencyPriceID === item?.value}
                        >
                          {item?.label} {item?.otherName} {item?.priceValue}
                        </option>
                      );
                    })}
                  </select>
                  {CurrencyPriceError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {CurrencyPriceError}
                    </span>
                  )}
                </div>
              </>
            ) : (
              <></>
            )}

            <label className="col-md-4 col-form-label">
              Your subscribed package auto renewal
            </label>
            <div className="searchForm col-md-8">
              <input
                type="checkbox"
                value=""
                disabled={isPaymentshow || iscash}
                id="autorenewal"
                checked={autorenewal}
                onChange={(e) => {
                  setautorenewal(!autorenewal);
                }}
              />
            </div>

            <label className="col-md-4 col-form-label">
              Cash payment method
            </label>
            <div className="searchForm col-md-8">
              <div>
                <input
                  type="radio"
                  value="Cash"
                  checked={iscash === true ? true : false}
                  name="Payment"
                  className="mr-2"
                  onChange={(e) => {
                    setiscash(true);
                    setautorenewal(false);
                  }}
                />{" "}
                Cash
                {/* <input
                  type="radio"
                  value="Card"
                  checked={iscash === false ? true : false}
                  name="Payment"
                  className="mr-2 ml-2"
                  onChange={(e) => {
                    setiscash(false);
                  }}
                />{" "}
                Card */}
              </div>
            </div>
          </div>
          <div className="form-group row m-b-10 flex-wrap mt-4">
            <div className="my-2  my-xl-0 ml-md-2">
              {isPaymentshow ? (
                iscash ? (
                  <button
                    type="button"
                    className="btn  btn-primary m-r-5 shadow-add"

                    onClick={async () => {
                      let checkLogin = userRef?.current?._id;
                      if (checkLogin) {
                        const checkuserlock = await CheckUserIslock(checkLogin);
                        if (checkuserlock === false || checkuserlock === false) {
                          swal(
                            "oops!",
                            "Sorry! You can not do any transaction in 1 hour.",
                            "warning"
                          );
                        }
                        else {
                          Cashcreatepackage();
                        }
                      }
                    }}
                  >
                    {"Pay Cash " + "(" + totalPrice + ")"}
                  </button>
                ) : (
                  <></>
                  
                )
              ) : (
                <button
                  type="button"
                  className="btn  btn-primary m-r-5 shadow-add"
                  onClick={async () => {
                    let checkLogin = userRef?.current?._id;
                    if (checkLogin) {
                      const checkuserlock = await CheckUserIslock(checkLogin);
                      if (checkuserlock === false || checkuserlock === false) {
                        swal(
                          "oops!",
                          "Sorry! You can not do any transaction in 1 hour.",
                          "warning"
                        );
                      }
                      else {
                        Proceedpackage();
                      }
                    }
                  }}
                >
                  Proceed
                </button>
              )}
            </div>
            <div className="my-2  my-xl-0 ml-md-2">
              <button
                type="button"
                className="btn  btn-danger m-r-5 shadow-add"
                onClick={() => {
                  togglePackageclose();
                }}
              >
                Cancel
              </button>
            </div>
          </div>

          {
            isPackageDetailShow ? <>
              <h5>Package Detail </h5>

              <div class="px-4 py-3 rounded">
                <div className="row">
                  <div className="col-md-6 col-sm-6 col-6">
                    <div>
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="help-text-simple">
                          <b>
                            {" "}
                            <img
                              src="assets/img/tick-mark-icon-png-7.png"
                              height="24"
                            />
                          </b>
                          {" "}
                          <b> {(PackageDetailitem?.apDynamicQrCodeCount === -1 || PackageDetailitem?.apDynamicQrCodeCount === "-1") ? "Unlimited" : PackageDetailitem?.apDynamicQrCodeCount}</b> &nbsp; Product / Article QR Codes
                        </p>
                      </div>
                    </div>
                    {/* {
                        CurrencyPricelist?.map((citem) => {
                          return <p class="help-text-simple">
                            {" "}
                            <b> {citem?.label} {citem?.otherName} {citem?.priceValue}</b> &nbsp; Price
                          </p>
                        })
                      } */}
                    <div>
                      <div class="d-flex justify-content-between align-items-center">
                        <p class="help-text-simple">
                          <b>
                            {" "}
                            <img
                              src="assets/img/tick-mark-icon-png-7.png"
                              height="24"
                            />
                          </b>
                          {" "}

                          <b> {bytesToSize(PackageDetailitem?.dataStorageCount)}</b> &nbsp; Data storage limit
                        </p>
                      </div>
                    </div>
                    <div>
                      {
                        PackageDetailitem?.isWeb === true && (
                          <div class="d-flex justify-content-between align-items-center">
                            <p class="help-text-simple">
                              {/* <b> Unlimited </b> &nbsp;Dynamic QR Code (100% Free)
                                  for URL, Text, Email, Phone, SMS, Calendar, WIFI,
                                  Personal V Card,
                                </p> */}
                              <b>
                                {" "}
                                <img
                                  src="assets/img/tick-mark-icon-png-7.png"
                                  height="24"
                                />
                              </b>
                              {" "}

                              <b> {(PackageDetailitem?.dynamicQrCodeCount === -1 || PackageDetailitem?.dynamicQrCodeCount === "-1") ? "Unlimited" : PackageDetailitem?.dynamicQrCodeCount} </b> &nbsp;Dynamic QR Code
                            </p>
                          </div>
                        )}
                    </div>
                    {
                      PackageDetailitem?.isWeb === true && (
                        <>
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                {" "}

                                <b> {(PackageDetailitem?.staticQrCodeCount === -1 || PackageDetailitem?.staticQrCodeCount === "-1") ? "Unlimited" : PackageDetailitem?.staticQrCodeCount} </b> &nbsp; Static QR Code
                              </p>
                            </div>
                          </div>
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                {" "}

                                <b> {(PackageDetailitem?.bulkQrCodeCount === -1 || PackageDetailitem?.bulkQrCodeCount === "-1") ? "Unlimited" : PackageDetailitem?.bulkQrCodeCount} </b> &nbsp; Bulk QR Code
                              </p>
                            </div>
                          </div>
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                {" "}

                                <b>{(PackageDetailitem?.monthlyScanCount === -1 || PackageDetailitem?.monthlyScanCount === "-1") ? "Unlimited" : PackageDetailitem?.monthlyScanCount}</b> &nbsp;Monthly scans
                              </p>
                            </div>
                          </div>
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                {" "}

                                <b> {(PackageDetailitem?.subAccountCount === -1 || PackageDetailitem?.subAccountCount === "-1") ? "Unlimited" : PackageDetailitem?.subAccountCount}</b>&nbsp; Users and team accounts
                              </p>
                            </div>
                          </div>
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                {" "}

                                <b>{(PackageDetailitem?.noOfChatUser === -1 || PackageDetailitem?.noOfChatUser === "-1") ? "Unlimited" : PackageDetailitem?.noOfChatUser}</b>&nbsp; Number of Chatting users{" "}
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                  </div>
                  {
                    PackageDetailitem?.isWeb === true && (
                      <div className="col-md-6 col-sm-6 col-6">
                        {PackageDetailitem?.isChatEnabled ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp; Article and bulk QR Code chat enabled{" "}
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                        {PackageDetailitem?.isSSLCertificate ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp;SSL Certificate with QR Code
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                        {PackageDetailitem?.isQrCodeSaveInWallet ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp;QR Code saving to STT Smart wallet{" "}
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                        {PackageDetailitem?.isQrCodeCategoryManaged ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp;QR Codes categories management
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                        {PackageDetailitem?.isAdvanceQrCodeSearch ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp; Advance QR Code search{" "}
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                        {PackageDetailitem?.isAdvanceQrCodeSearch ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp;Advance scanning analytics
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                        {PackageDetailitem?.isExportQrCode ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp;Export QR Code data{" "}
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                        {PackageDetailitem?.isEmailSupport ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp;Email support{" "}
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                        {PackageDetailitem?.isIndividualPhoneSupport ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp;Individual phone support{" "}
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                        {PackageDetailitem?.isYourBranding ?
                          <div>
                            <div class="d-flex justify-content-between align-items-center">
                              <p class="help-text-simple">
                                <b>
                                  {" "}
                                  <img
                                    src="assets/img/tick-mark-icon-png-7.png"
                                    height="24"
                                  />
                                </b>
                                &nbsp;Your branding{" "}
                              </p>
                            </div>
                          </div>
                          : <></>
                        }
                      </div>
                    )}
                </div>
                <div class="text-center mt-3 mb-3">
                </div>
              </div>
            </> : <></>
          }
        </ModalBody>
      </Modal>
      <Modal
        isOpen={packageaddeditmodalopen}
        toggle={toggleAddPackageModal}
        className="modal-size"
      >
        <ModalHeader toggle={toggleAddPackageModal} className="modalheader">
          <h4 className="text-white mb-0">{"Add Customised Package"}</h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <div className="row">

              {/* <div className="col-xl-6 col-lg-6">
                <div className="mt-2">
                  <input
                    disabled={true}
                    type="checkbox"
                    value=""
                    id="IsWeb"
                    checked={IsWeb}
                    onChange={(e) => {
                      
                    }}
                  />
                  <label htmlFor="IsWeb" className="ml-2">
                    {" "}
                    Web
                  </label>
                </div>
              </div> */}
              {/* <div className="col-xl-6 col-lg-6">
                <div className="mt-2">
                  <input
                    disabled={true}
                    type="checkbox"
                    value=""
                    id="IsMobile"
                    checked={IsWeb === false ? true : false}
                    onChange={(e) => {
                     
                    }}
                  />
                  <label htmlFor="IsMobile" className="ml-2">
                    {" "}
                    Mobile
                  </label>
                </div>
              </div> */}
              <div className="col-xl-12 col-lg-12">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Package name</h5>
                </label>
                <input
                  type="text"
                  maxlength="30"
                  className="form-control mb-2"
                  placeholder="Please Enter package name "
                  value={packagename}
                  onChange={(event) => {
                    setpackagenameError("");
                    setpackagename(event.target.value);
                  }}
                />

                {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {packagename?.length}/30
                </p> */}
                {packagenameError.length > 0 && (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {packagenameError}
                  </span>
                )}
              </div>

              <div className="col-xl-12 col-lg-12">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Package Category</h5>
                </label>
                <div className="searchForm">
                  <select
                    className="default-select2 form-control mb-2"
                    onChange={(e) => {
                      setselectpackageCategoryError("");
                      setselectpackageCategory(e.target.value);
                    }}
                  >
                    <option value="" selected={selectpackageCategory === ""}>
                      select package Category
                    </option>
                    {packagecategory.map((item) => {
                      return (
                        <option
                          value={item?.value}
                          selected={selectpackageCategory === item?.value}
                        >
                          {item?.text}
                        </option>
                      );
                    })}
                  </select>
                  {selectpackageCategoryError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {selectpackageCategoryError}
                    </span>
                  )}
                </div>
              </div>

              <div className="col-xl-4 col-lg-4">
                <div className="mt-2">
                  <input
                    type="checkbox"
                    value=""
                    id="IsMonthly"
                    checked={IsMonthly}
                    onChange={async (e) => {
                      await getfixePackage(IsWeb, true);
                      setIsMonthly(true);
                      setIsYearly(false);
                    }}
                  />
                  <label htmlFor="IsMonthly" className="ml-2">
                    {" "}
                    Monthly
                  </label>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4">
                <div className="mt-2">
                  <input
                    type="checkbox"
                    value=""
                    id="IsYearly"
                    checked={IsYearly}
                    onChange={async (e) => {
                      await getfixePackage(IsWeb, false);
                      setIsMonthly(false);
                      setIsYearly(true);
                    }}
                  />
                  <label htmlFor="IsSSLCertificate" className="ml-2">
                    {" "}
                    Yearly
                  </label>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4">
                <div className="mt-2">
                  <input
                    type="checkbox"
                    value=""
                    id="Isusercase"
                    checked={isusercase}
                    onChange={(e) => {
                      OnchnagesetCurrencyList(isusercase);
                    }}
                  />
                  <label htmlFor="Isusercase" className="ml-2">
                    {" "}
                    Cash Payment Method
                  </label>
                </div>
              </div>
              <div className="col-xl-12 col-lg-12">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Currency</h5>
                </label>
                <div className="searchForm">
                  {isusercase === true ? (
                    <Select
                      id="Cash"
                      value={selectedOptionIscash}
                      //defaultValue={selectedOptionIscash}
                      onChange={(e, index) => {
                        setSelectedOptionCash(e);
                        setSelectedOptionError("");
                        onChangecurrencyCash(e);
                      }}
                      placeholder="Select Currency..."
                      options={CurrencyList}
                    // isClearable={false}
                    />
                  ) : (
                    <Select
                      id="withoutcash"
                      // defaultValue={selectedOption}
                      value={selectedOption}
                      onChange={(e, index) => {
                        setSelectedOption(e);
                        setSelectedOptionError("");
                        onChangecurrency(index);
                      }}
                      placeholder="Select Currency..."
                      options={FixCurrencyList}
                      isMulti
                    />
                  )}

                  {selectedOptionError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {selectedOptionError}
                    </span>
                  )}
                </div>
              </div>
              {isusercase === true
                ? createCurrencyUICash()
                : createCurrencyUI()}

              <div className="col-xl-6 col-lg-6">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Dynamic QrCode Count</h5>
                </label>
                <input
                  type="text"
                  maxlength="20"
                  className="form-control mb-2"
                  placeholder="Please Enter Dynamic QrCode Count"
                  value={dynamicQrCodeCount}
                  onChange={(event) => {
                    setDynamicQrCodeCountError("");
                    setDynamicQrCodeCount(event.target.value);
                  }}
                />
                {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {dynamicQrCodeCount?.length}/20
                </p> */}
                {dynamicQrCodeCountError.length > 0 && (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {dynamicQrCodeCountError}
                  </span>
                )}
              </div>
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Bulk QrCode Count</h5>
                    </label>
                    <input
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Bulk QrCode"
                      value={bulkQrCodeCount}
                      onChange={(event) => {
                        setBulkQrCodeCountError("");
                        setbulkQrCodeCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {bulkQrCodeCount?.length}/20
                </p> */}
                    {bulkQrCodeCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {bulkQrCodeCountError}
                      </span>
                    )}
                  </div>
                  : <></>}
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">No Of Chat User</h5>
                    </label>
                    <input
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter No Of Chat User"
                      value={noofchatuserCount}
                      onChange={(event) => {
                        setNoofchatuserCountError("");
                        setNoofchatuserCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {noofchatuserCount?.length}/20
                </p> */}
                    {noofchatuserCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {noofchatuserCountError}
                      </span>
                    )}
                  </div>
                  : <></>}
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Monthly Scan Count</h5>
                    </label>
                    <input
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Monthly Scan Count"
                      value={monthlyCodeCount}
                      onChange={(event) => {
                        setmonthlyCodeCountError("");
                        setMonthlyCodeCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {monthlyCodeCount?.length}/20
                </p> */}
                    {monthlyCodeCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {monthlyCodeCountError}
                      </span>
                    )}
                  </div>
                  : <></>}
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Sub Account Count</h5>
                    </label>
                    <input
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Sub Account Count"
                      value={subaccountCount}
                      onChange={(event) => {
                        setSubaccountCountError("");
                        setSubaccountCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {subaccountCount?.length}/20
                </p> */}
                    {subaccountCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {subaccountCountError}
                      </span>
                    )}
                  </div>
                  : <></>}
              <div className="col-xl-6 col-lg-6">
                <label htmlFor="exampleInputEmail1">
                  <h5 className="mb-0">Data Storage Count</h5>
                </label>
                <NumericFormat
                  disabled={isdisabled}
                  thousandSeparator={true}
                  className="form-control mb-2"
                  placeholder={"Please Enter Data Storage Count only GB value"}
                  decimalScale={2}
                  fixedDecimalScale={false}
                  value={dataStorageCount}
                  onValueChange={(e) => {
                    setDataStorageCount(e.floatValue)
                  }}
                />
                {/* <input
                  type="text"
                  maxlength="15"
                  className="form-control mb-2"
                  // placeholder="Please Enter Data Storage Count only bytes value"
                  placeholder="Please Enter Data Storage Count only GB value"
                  value={dataStorageCount}
                  onChange={(event) => {
                    setDataStorageCountError("");
                    setDataStorageCount(event.target.value);
                  }}
                /> */}
                {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {dataStorageCount?.length}/15
                </p> */}
                {dataStorageCountError.length > 0 && (
                  <span style={{ color: "red", marginLeft: 6 }}>
                    {dataStorageCountError}
                  </span>
                )}
              </div>
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Static QrCode Count</h5>
                    </label>
                    <input
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Static QrCode Count"
                      value={staticCodeCount}
                      onChange={(event) => {
                        setStaticCodeCountError("");
                        setStaticCodeCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {staticCodeCount?.length}/20
                </p> */}
                    {staticCodeCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {staticCodeCountError}
                      </span>
                    )}
                  </div>
                  : <></>}
              {
                IsWeb ?
                  <div className="col-xl-6 col-lg-6">
                    <label htmlFor="exampleInputEmail1">
                      <h5 className="mb-0">Parsonal Dynamic QrCode Count</h5>
                    </label>
                    <input
                      type="text"
                      maxlength="20"
                      className="form-control mb-2"
                      placeholder="Please Enter Parsonal Dynamic QrCode Count"
                      value={personaldynamicQrCodeCount}
                      onChange={(event) => {
                        setPersonaldynamicQrCodeCountError("");
                        setPersonaldynamicQrCodeCount(event.target.value);
                      }}
                    />
                    {/* <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {personaldynamicQrCodeCount?.length}/20
                </p> */}
                    {personaldynamicQrCodeCountError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {personaldynamicQrCodeCountError}
                      </span>
                    )}
                  </div>
                  : <></>}

              {/* <div className="col-xl-4 col-lg-4">
                <div className="mt-2">
                  <input
                    disabled={true}
                    type="checkbox"
                    value=""
                    id="IsWeb"
                    checked={IsWeb}
                    onChange={(e) => {
                      if (isdisabled === false) {
                        setIsWeb(e.target.checked);
                      }
                    }}
                  />
                  <label htmlFor="IsWeb" className="ml-2">
                    {" "}
                    Is Web
                  </label>
                </div>
              </div> */}
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        disabled={true}
                        type="checkbox"
                        value=""
                        id="IsCustom"
                        checked={IsCustom}
                        onChange={(e) => {
                          // setIsCustom(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsCustom" className="ml-2">
                        {" "}
                        Is Custom
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsChatEnabled"
                        checked={ChatEnabled}
                        onChange={(e) => {
                          setChatEnabled(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsChatEnabled" className="ml-2">
                        {" "}
                        Chat Enabled
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsAutoRenewal"
                        checked={AutoRenewal}
                        onChange={(e) => {
                          setAutoRenewal(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsAutoRenewal" className="ml-2">
                        {" "}
                        Auto Renewal
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsSSLCertificate"
                        checked={SSLCertificate}
                        onChange={(e) => {
                          setSSLCertificate(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsSSLCertificate" className="ml-2">
                        {" "}
                        SSL Certificate
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsAdvanceQrCodeSearch"
                        checked={AdvanceQrCodeSearch}
                        onChange={(e) => {
                          setAdvanceQrCodeSearch(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsAdvanceQrCodeSearch" className="ml-2">
                        {" "}
                        Advance QrCode Search
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsQrCodeSaveInWallet"
                        checked={QrCodeSaveInWallet}
                        onChange={(e) => {
                          setQrCodeSaveInWallet(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsQrCodeSaveInWallet" className="ml-2">
                        {" "}
                        QrCode Save In Wallet
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsQrCodeCategoryManaged"
                        checked={QrCodeCategoryManaged}
                        onChange={(e) => {
                          setQrCodeCategoryManaged(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsQrCodeCategoryManaged" className="ml-2">
                        {" "}
                        QrCode Category Managed
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsExportQrCode"
                        checked={ExportQrCode}
                        onChange={(e) => {
                          setExportQrCode(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsExportQrCode" className="ml-2">
                        {" "}
                        Export QrCode
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsEmailSupport"
                        checked={EmailSupport}
                        onChange={(e) => {
                          setEmailSupport(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsEmailSupport" className="ml-2">
                        {" "}
                        Email Support
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsIndividualSupport"
                        checked={IndividualSupport}
                        onChange={(e) => {
                          setIndividualSupport(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsIndividualSupport" className="ml-2">
                        {" "}
                        Individual Support
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IndividualPhoneSupport"
                        checked={IndividualPhoneSupport}
                        onChange={(e) => {
                          setIndividualPhoneSupport(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsIndividualPhoneSupport" className="ml-2">
                        {" "}
                        Individual Phone Support
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsWhiteLabelling"
                        checked={WhiteLabelling}
                        onChange={(e) => {
                          setWhiteLabelling(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsWhiteLabelling" className="ml-2">
                        {" "}
                        Tag Line
                      </label>
                    </div>
                  </div>
                  : <></>
              }
              {
                IsWeb ?
                  <div className="col-xl-4 col-lg-4">
                    <div className="mt-2">
                      <input
                        type="checkbox"
                        value=""
                        id="IsYourBranding"
                        checked={YourBranding}
                        onChange={(e) => {
                          setYourBranding(e.target.checked);
                        }}
                      />
                      <label htmlFor="IsYourBranding" className="ml-2">
                        {" "}
                        Your Branding
                      </label>
                    </div>
                  </div>
                  : <></>
              }
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <button
              type="button"
              className="btn btn-sm btn-primary m-r-5 shadow-add"
              onClick={() => {
                submitSystempackage();
              }}
            >
              {SystempackageID.length === 0 ? "Create" : "Update"}
            </button>
            <button
              className="btn btn-sm btn-danger shadow-add "
              onClick={() => {
                // togglePackageclose();
                toggleAddPackageModal();
              }}
            >
              Cancel
            </button>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={PendingPackageModalisOpen}
        toggle={PendingPackageModalisOpen}
        className="modal-size"
      >
        <ModalHeader toggle={togglePendingPackageclose} className="modalheader">
          <h4 className="text-white mb-0">Assign package</h4>
        </ModalHeader>
        <ModalBody>
          <div className="form-group row m-b-10 flex-wrap">
            <label className="col-md-4 col-form-label" htmlFor="autorenewal">
              Your subscribed package
            </label>
            <div className="searchForm col-md-8">
              <h5>
                {selectpendingPackage?.packageName
                  ? selectpendingPackage?.packageName
                  : "N/A"}
              </h5>
            </div>
            <label
              className="col-md-4 col-form-label"
            // htmlFor="autorenewal"
            >
              Package Price
            </label>
            <div className="searchForm col-md-8">
              <select
                disabled={isPaymentshow}
                className="default-select2 form-control"
                onChange={(e) => {
                  setCurrencyPriceError("");
                  setAssignCurrencyPriceID(e.target.value);
                }}
              >
                <option value={""} selected={AssignCurrencyPriceID === ""}>
                  {"--- select package price ---"}
                </option>
                {AssignCurrencyPricelist?.map((item) => {
                  return (
                    <option
                      value={item?.value}
                      selected={AssignCurrencyPriceID === item?._id}
                    >
                      {item?.label} {item?.otherName} {item?.priceValue}
                    </option>
                  );
                })}
              </select>
              {CurrencyPriceError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {CurrencyPriceError}
                </span>
              )}
            </div>
            <label className="col-md-4 col-form-label">
              Your subscribed package auto renewal
            </label>
            <div className="searchForm col-md-8">
              <input
                type="checkbox"
                value=""
                disabled={isPaymentshow || iscash}
                id="autorenewal"
                checked={autorenewal}
                onChange={(e) => {
                  setautorenewal(!autorenewal);
                }}
              />
            </div>

            <label className="col-md-4 col-form-label">Payment method</label>
            <div className="searchForm col-md-8">
              <div>
                <input
                  disabled={isPaymentshow}
                  type="radio"
                  value="Cash"
                  checked={iscash === true ? true : false}
                  name="Payment"
                  className="mr-2"
                  onChange={(e) => {
                    setiscash(true);
                    setautorenewal(false);
                  }}
                />{" "}
                Cash
                <input
                 disabled={isPaymentshow}
                  type="radio"
                  value="Card"
                  checked={iscash === false ? true : false}
                  name="Payment"
                  className="mr-2 ml-2"
                  onChange={(e) => {
                    setiscash(false);
                  }}
                />{" "}
                Card

              </div>
            </div>
          </div>
          <div className="form-group row m-b-10 flex-wrap mt-4">
            <div className="my-2  my-xl-0 ml-md-2">
              {isPaymentshow ? (
                iscash ? (
                  <button
                    type="button"
                    className="btn  btn-primary m-r-5 shadow-add"
                    onClick={async () => {
                      // alert("case");
                      let checkLogin = userRef?.current?._id;
                      if (checkLogin) {
                        const checkuserlock = await CheckUserIslock(checkLogin);
                        if (checkuserlock === false || checkuserlock === false) {
                          swal(
                            "oops!",
                            "Sorry! You can not do any transaction in 1 hour.",
                            "warning"
                          );
                        }
                        else {
                          CashcreatePendingpackage();
                        }
                      }
                    }}
                  >
                    {"Pay Cash (" + totalPrice + ")"}
                  </button>
                ) : (
                  <></>
                  // <button
                  //   type="button"
                  //   className="btn  btn-primary m-r-5 shadow-add"
                  //   onClick={async () => {
                  //     let checkLogin = userRef?.current?._id;
                  //     if (checkLogin) {
                  //       const checkuserlock = await CheckUserIslock(checkLogin);
                  //       if (checkuserlock === false || checkuserlock === false) {
                  //         swal(
                  //           "oops!",
                  //           "Sorry! You can not do any transaction in 1 hour.",
                  //           "warning"
                  //         );
                  //       }
                  //       else {
                  //         onSubmitPending();
                  //       }
                  //     }

                  //   }}
                  // >
                  //   {"Pay (" + totalPrice + " )"}
                  // </button>
                )
              ) : (

                <>
                  {
                    iscash === true ?
                      <button
                        type="button"
                        className="btn  btn-primary m-r-5 shadow-add"
                        onClick={async () => {
                          let checkLogin = userRef?.current?._id;
                          if (checkLogin) {
                            const checkuserlock = await CheckUserIslock(checkLogin);
                            if (checkuserlock === false || checkuserlock === false) {
                              swal(
                                "oops!",
                                "Sorry! You can not do any transaction in 1 hour.",
                                "warning"
                              );
                            }
                            else {
                              ProceedPendingpackage();
                            }
                          }
                        }}
                      >
                        Proceed
                      </button>
                      : <button
                        type="button"
                        className="btn  btn-primary m-r-5 shadow-add"
                        onClick={async () => {
                          let checkLogin = userRef?.current?._id;
                          if (checkLogin) {
                            const checkuserlock = await CheckUserIslock(checkLogin);
                            if (checkuserlock === false || checkuserlock === false) {
                              swal(
                                "oops!",
                                "Sorry! You can not do any transaction in 1 hour.",
                                "warning"
                              );
                            }
                            else {
                              let checkLogin = userRef?.current?._id;
                              let PaymentID = selectpendingPackage?.userPackagePaymentID;
                              CustomPackagelinksend(checkLogin, PaymentID, AssignCurrencyPriceID);
                            }
                          }
                        }}
                      >
                        Send link
                      </button>
                  }

                </>
              )}
            </div>
            <div className="my-2  my-xl-0 ml-md-2">
              <button
                type="button"
                className="btn  btn-danger m-r-5 shadow-add"
                onClick={() => {
                  togglePendingPackageclose();
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={UsersassignedpackageinfoIsshow}
        toggle={userdetailmadalOpen}
        className="modal-size"
      >
        <ModalHeader
          toggle={toggleUserpackageinfoModal}
          className="modalheader"
        >
          <h4 className="text-white mb-0">
            Users assigned package details info
          </h4>
        </ModalHeader>
        <ModalBody>
          <Panel className="mt-2">
            <PanelHeader>
              <div className="d-md-flex align-items-center">
                <h4 className="mb-0 text-light">
                  {Packageinforef?.current?.packageName
                    ? Packageinforef?.current?.packageName
                    : "N/A"}
                </h4>
              </div>
            </PanelHeader>
            <PanelBody>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table className="table m-b-0 table-bordered table-striped text-center">
                        <thead>
                          <tr>
                            <th>Sr.No</th>
                            <th>Entity</th>
                            <th>Allowed</th>
                            <th>Consumed</th>
                            <th>Remaining</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Article and Product Dynamic QrCode Count </td>
                            <td>
                              {(Packageinforef?.current?.apDynamicQrCodeCount === -1 || Packageinforef?.current?.apDynamicQrCodeCount === "-1") ? "Unlimited" : Packageinforef?.current?.apDynamicQrCodeCount}

                            </td>
                            <td>
                              {Packageinforef?.current?.apDynamicQrCodeCountUsed
                                ? Packageinforef?.current
                                  ?.apDynamicQrCodeCountUsed
                                : 0}
                            </td>
                            <td>
                              {Packageinforef?.current?.apDynamicQrCodeCount
                                ? Packageinforef?.current
                                  ?.apDynamicQrCodeCount === -1
                                  ? "Unlimited"
                                  : Packageinforef?.current
                                    ?.apDynamicQrCodeCount -
                                  Packageinforef?.current
                                    ?.apDynamicQrCodeCountUsed
                                : 0}
                            </td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td>Storage capacity</td>
                            <td>
                              {Packageinforef?.current?.dataStorageCount === -1
                                ? "Unlimited"
                                : bytesToSize(
                                  Packageinforef?.current?.dataStorageCount
                                    ? Packageinforef?.current
                                      ?.dataStorageCount
                                    : 0
                                )}
                            </td>
                            <td>
                              {bytesToSize(
                                Packageinforef?.current?.dataStorageCountUsed
                                  ? Packageinforef?.current
                                    ?.dataStorageCountUsed
                                  : 0
                              )}
                            </td>
                            <td>
                              {Packageinforef?.current?.dataStorageCount === -1
                                ? "Unlimited"
                                : bytesToSizeRemaining(
                                  Packageinforef?.current?.dataStorageCount
                                    ? Packageinforef?.current
                                      ?.dataStorageCount
                                    : 0,
                                  Packageinforef?.current
                                    ?.dataStorageCountUsed
                                    ? Packageinforef?.current
                                      ?.dataStorageCountUsed
                                    : 0
                                )}
                            </td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td>Monthly scans</td>
                            <td>
                              {Packageinforef?.current?.monthlyScanCount
                                ? Packageinforef?.current?.monthlyScanCount ===
                                  -1
                                  ? "Unlimited"
                                  : Packageinforef?.current?.monthlyScanCount
                                : 0}
                            </td>
                            <td>
                              {Packageinforef?.current?.monthlyScanCountUsed}
                            </td>
                            <td>
                              {Packageinforef?.current?.monthlyScanCount
                                ? Packageinforef?.current?.monthlyScanCount ===
                                  -1
                                  ? "Unlimited"
                                  : Packageinforef?.current?.monthlyScanCount -
                                  Packageinforef?.current
                                    ?.monthlyScanCountUsed
                                : 0}
                            </td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td>User accounts</td>
                            <td>
                              {Packageinforef?.current?.subAccountCount
                                ? Packageinforef?.current?.subAccountCount ===
                                  -1
                                  ? "Unlimited"
                                  : Packageinforef?.current?.subAccountCount
                                : 0}
                            </td>
                            <td>
                              {Packageinforef?.current?.subAccountCountUsed
                                ? Packageinforef?.current?.subAccountCountUsed
                                : 0}
                            </td>
                            <td>
                              {Packageinforef?.current?.subAccountCount === -1
                                ? "Unlimited"
                                : Packageinforef?.current?.subAccountCount -
                                Packageinforef?.current?.subAccountCountUsed}
                            </td>
                          </tr>
                          <tr>
                            <td>5</td>
                            <td>Chatting user</td>
                            <td>
                              {Packageinforef?.current?.noOfChatUser == -1
                                ? "Unlimited"
                                : Packageinforef?.current?.noOfChatUser}
                            </td>
                            <td>
                              {Packageinforef?.current?.noOfChatUserCountUsed}
                            </td>
                            <td>
                              {Packageinforef?.current?.noOfChatUser == -1
                                ? "Unlimited"
                                : Packageinforef?.current?.noOfChatUser -
                                Packageinforef?.current
                                  ?.noOfChatUserCountUsed}
                            </td>
                          </tr>
                          <tr>
                            <td>6</td>
                            <td>Dynamic QR Code</td>
                            <td>
                              {Packageinforef?.current?.dynamicQrCodeCount == -1
                                ? "Unlimited"
                                : Packageinforef?.current?.dynamicQrCodeCount}
                            </td>
                            <td>
                              {Packageinforef?.current?.dynamicQrCodeCountUsed}
                            </td>
                            <td>
                              {Packageinforef?.current?.dynamicQrCodeCount == -1
                                ? "Unlimited"
                                : Packageinforef?.current?.dynamicQrCodeCount -
                                Packageinforef?.current
                                  ?.dynamicQrCodeCountUsed}
                            </td>
                          </tr>
                          <tr>
                            <td>7</td>
                            <td>Static QR Codes</td>
                            <td>
                              {Packageinforef?.current?.staticQrCodeCount == -1
                                ? "Unlimited"
                                : Packageinforef?.current?.staticQrCodeCount}
                            </td>
                            <td>
                              {Packageinforef?.current?.staticQrCodeCountUsed}
                            </td>
                            <td>
                              {Packageinforef?.current?.staticQrCodeCount == -1
                                ? "Unlimited"
                                : Packageinforef?.current?.staticQrCodeCount -
                                Packageinforef?.current
                                  ?.staticQrCodeCountUsed}
                            </td>
                          </tr>
                          <tr>
                            <td>8</td>
                            <td>Bulk QrCode Count</td>
                            <td>
                              {Packageinforef?.current?.bulkQrCodeCount == -1
                                ? "Unlimited"
                                : Packageinforef?.current?.bulkQrCodeCount}
                            </td>
                            <td>
                              {Packageinforef?.current?.bulkQrCodeCountUsed}
                            </td>
                            <td>
                              {Packageinforef?.current?.staticQrCodeCount == -1
                                ? "Unlimited"
                                : Packageinforef?.current?.bulkQrCodeCount -
                                Packageinforef?.current?.bulkQrCodeCountUsed}
                            </td>
                          </tr>
                          <tr>
                            <td>9</td>
                            <td>Chat Enabled</td>
                            <td>
                              {Packageinforef?.current?.isChatEnabled
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>SSLCertificate</td>
                            <td>
                              {Packageinforef?.current?.isSSLCertificate
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>11</td>
                            <td>Advance QrCode Search</td>
                            <td>
                              {Packageinforef?.current?.isAdvanceQrCodeSearch
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>12</td>
                            <td>QrCode Save In Wallet</td>
                            <td>
                              {Packageinforef?.current?.isQrCodeSaveInWallet
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>13</td>
                            <td>QrCode Category Managed</td>
                            <td>
                              {Packageinforef?.current?.isQrCodeCategoryManaged
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>14</td>
                            <td>Export QrCode</td>
                            <td>
                              {Packageinforef?.current?.isExportQrCode
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>15</td>
                            <td>Email Support</td>
                            <td>
                              {Packageinforef?.current?.isEmailSupport
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>16</td>
                            <td>Individual Support</td>
                            <td>
                              {Packageinforef?.current?.isIndividualSupport
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>17</td>
                            <td>Individual Phone Support</td>
                            <td>
                              {Packageinforef?.current?.isIndividualPhoneSupport
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>18</td>
                            <td>Tag Line</td>
                            <td>
                              {Packageinforef?.current?.isWhiteLabelling
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                          <tr>
                            <td>19</td>
                            <td>Your Branding</td>
                            <td>
                              {Packageinforef?.current?.isYourBranding
                                ? "Yes"
                                : "No"}
                            </td>
                            <td>{"-"}</td>
                            <td>{"-"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </ModalBody>
      </Modal>
    </div >
  );
}

export default User;
